/* tslint:disable */
/* eslint-disable */
/**
 * Bokita API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.5.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AuthorizationRequest
 */
export interface AuthorizationRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthorizationRequest
     */
    userName?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthorizationRequest
     */
    password?: string;
}
/**
 * 
 * @export
 * @interface AuthorizationResponse
 */
export interface AuthorizationResponse {
    /**
     * 
     * @type {string}
     * @memberof AuthorizationResponse
     */
    token?: string;
    /**
     * 
     * @type {number}
     * @memberof AuthorizationResponse
     */
    expiresInSeconds?: number;
    /**
     * 
     * @type {string}
     * @memberof AuthorizationResponse
     */
    userId?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum AuthorizationTypeEnum {
    None = 'None',
    Internal = 'Internal',
    External = 'External'
}

/**
 * 
 * @export
 * @interface BcbUnassignedDto
 */
export interface BcbUnassignedDto {
    /**
     * 
     * @type {string}
     * @memberof BcbUnassignedDto
     */
    bcbId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BcbUnassignedDto
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BcbUnassignedDto
     */
    statusReason?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BcbUnassignedDto
     */
    statusUpdatedTime?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BcbUnassignedDto
     */
    connected?: boolean;
}
/**
 * 
 * @export
 * @interface ConnectionConfigurationDto
 */
export interface ConnectionConfigurationDto {
    /**
     * 
     * @type {string}
     * @memberof ConnectionConfigurationDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ConnectionConfigurationDto
     */
    sourceDockNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof ConnectionConfigurationDto
     */
    sourceDeviceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof ConnectionConfigurationDto
     */
    triggerEvent?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ConnectionConfigurationDto
     */
    triggerEventParameters?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof ConnectionConfigurationDto
     */
    targetDockNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof ConnectionConfigurationDto
     */
    targetDeviceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof ConnectionConfigurationDto
     */
    targetAction?: string;
    /**
     * 
     * @type {string}
     * @memberof ConnectionConfigurationDto
     */
    status?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ConnectionConfigurationDto
     */
    targetActionParameters?: { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface ConnectionConfigurationNewDto
 */
export interface ConnectionConfigurationNewDto {
    /**
     * 
     * @type {string}
     * @memberof ConnectionConfigurationNewDto
     */
    sourceDockNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof ConnectionConfigurationNewDto
     */
    sourceDeviceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof ConnectionConfigurationNewDto
     */
    triggerEvent?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ConnectionConfigurationNewDto
     */
    triggerEventParameters?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof ConnectionConfigurationNewDto
     */
    targetDockNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof ConnectionConfigurationNewDto
     */
    targetDeviceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof ConnectionConfigurationNewDto
     */
    targetAction?: string;
    /**
     * 
     * @type {any}
     * @memberof ConnectionConfigurationNewDto
     */
    targetActionParameters?: any | null;
}
/**
 * 
 * @export
 * @interface ContainerDto
 */
export interface ContainerDto {
    /**
     * 
     * @type {string}
     * @memberof ContainerDto
     */
    name?: string;
    /**
     * 
     * @type {ContainerStatusEnum}
     * @memberof ContainerDto
     */
    status?: ContainerStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ContainerDto
     */
    image?: string;
    /**
     * 
     * @type {string}
     * @memberof ContainerDto
     */
    version?: string;
    /**
     * 
     * @type {string}
     * @memberof ContainerDto
     */
    imageName?: string;
    /**
     * 
     * @type {string}
     * @memberof ContainerDto
     */
    statusDescription?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ContainerDto
     */
    exitCode?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ContainerDto
     */
    startTimeUtc?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContainerDto
     */
    lastExitTimeUtc?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContainerDto
     */
    lastRestartTimeUtc?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ContainerDto
     */
    restartCount?: number | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum ContainerStatusEnum {
    Unknown = 'unknown',
    Backoff = 'backoff',
    Running = 'running',
    Unhealthy = 'unhealthy',
    Stopped = 'stopped',
    Failed = 'failed'
}

/**
 * 
 * @export
 * @interface DeviceActionDto
 */
export interface DeviceActionDto {
    /**
     * 
     * @type {string}
     * @memberof DeviceActionDto
     */
    dockNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof DeviceActionDto
     */
    deviceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof DeviceActionDto
     */
    action?: string;
    /**
     * 
     * @type {any}
     * @memberof DeviceActionDto
     */
    actionParameters?: any | null;
}
/**
 * 
 * @export
 * @interface DeviceConfigurationDto
 */
export interface DeviceConfigurationDto {
    /**
     * 
     * @type {string}
     * @memberof DeviceConfigurationDto
     */
    dockNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof DeviceConfigurationDto
     */
    deviceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof DeviceConfigurationDto
     */
    key?: string;
    /**
     * 
     * @type {any}
     * @memberof DeviceConfigurationDto
     */
    value?: any | null;
}
/**
 * Specifies the different connection states of a device.
 * @export
 * @enum {string}
 */

export enum DeviceConnectionState {
    Disconnected = 'Disconnected',
    Connected = 'Connected'
}

/**
 * 
 * @export
 * @interface DeviceLevelPowerConsumptionDto
 */
export interface DeviceLevelPowerConsumptionDto {
    /**
     * 
     * @type {string}
     * @memberof DeviceLevelPowerConsumptionDto
     */
    zigbeeId?: string;
    /**
     * 
     * @type {number}
     * @memberof DeviceLevelPowerConsumptionDto
     */
    deviceNumber?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceLevelPowerConsumptionDto
     */
    deviceSymbol?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceLevelPowerConsumptionDto
     */
    snapInCode?: string;
    /**
     * 
     * @type {OldPowerState}
     * @memberof DeviceLevelPowerConsumptionDto
     */
    powerState?: OldPowerState;
}
/**
 * 
 * @export
 * @interface DeviceStateDataDto
 */
export interface DeviceStateDataDto {
    /**
     * 
     * @type {number}
     * @memberof DeviceStateDataDto
     */
    deviceNumber?: number | null;
    /**
     * 
     * @type {Array<StateDto>}
     * @memberof DeviceStateDataDto
     */
    states?: Array<StateDto>;
    /**
     * 
     * @type {DeviceTypeEnum}
     * @memberof DeviceStateDataDto
     */
    deviceType?: DeviceTypeEnum;
}
/**
 * 
 * @export
 * @interface DeviceStatusDto
 */
export interface DeviceStatusDto {
    /**
     * 
     * @type {DeviceConnectionState}
     * @memberof DeviceStatusDto
     */
    status?: DeviceConnectionState;
    /**
     * 
     * @type {Array<ContainerDto>}
     * @memberof DeviceStatusDto
     */
    containers?: Array<ContainerDto>;
    /**
     * 
     * @type {Array<ContainerDto>}
     * @memberof DeviceStatusDto
     */
    systemContainers?: Array<ContainerDto>;
    /**
     * 
     * @type {string}
     * @memberof DeviceStatusDto
     */
    lastReportedTime?: string;
}
/**
 * 
 * @export
 * @interface DeviceTypeConfigurationDefault
 */
export interface DeviceTypeConfigurationDefault {
    /**
     * 
     * @type {ObjectId}
     * @memberof DeviceTypeConfigurationDefault
     */
    id?: ObjectId;
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeConfigurationDefault
     */
    validationRuleSets?: string;
    /**
     * 
     * @type {number}
     * @memberof DeviceTypeConfigurationDefault
     */
    version?: number;
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeConfigurationDefault
     */
    name?: string;
    /**
     * 
     * @type {SwitchConfigurationDefault}
     * @memberof DeviceTypeConfigurationDefault
     */
    switchConfigurationDefault?: SwitchConfigurationDefault;
}
/**
 * 
 * @export
 * @interface DeviceTypeConfigurationDefaultAllOf
 */
export interface DeviceTypeConfigurationDefaultAllOf {
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeConfigurationDefaultAllOf
     */
    name?: string;
    /**
     * 
     * @type {SwitchConfigurationDefault}
     * @memberof DeviceTypeConfigurationDefaultAllOf
     */
    switchConfigurationDefault?: SwitchConfigurationDefault;
}
/**
 * 
 * @export
 * @interface DeviceTypeConfigurationDefaultDto
 */
export interface DeviceTypeConfigurationDefaultDto {
    /**
     * 
     * @type {SwitchConfigurationDefaultDto}
     * @memberof DeviceTypeConfigurationDefaultDto
     */
    switchConfigurationDefault?: SwitchConfigurationDefaultDto;
}
/**
 * 
 * @export
 * @interface DeviceTypeDto
 */
export interface DeviceTypeDto {
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeDto
     */
    symbol?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeDto
     */
    name?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof DeviceTypeDto
     */
    actions?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof DeviceTypeDto
     */
    events?: { [key: string]: any; };
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum DeviceTypeEnum {
    FrameButton = 'FrameButton',
    FrameLed = 'FrameLed',
    SwitchPulse = 'SwitchPulse',
    Buzzer = 'Buzzer',
    DeviceLed = 'DeviceLed',
    PowerSocket = 'PowerSocket',
    RelayBin = 'RelayBin',
    SmokeDetector = 'SmokeDetector'
}

/**
 * 
 * @export
 * @interface DockDto
 */
export interface DockDto {
    /**
     * 
     * @type {string}
     * @memberof DockDto
     */
    number?: string;
    /**
     * 
     * @type {string}
     * @memberof DockDto
     */
    typeId?: string;
    /**
     * 
     * @type {string}
     * @memberof DockDto
     */
    snapInCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DockDto
     */
    positionId?: string;
    /**
     * 
     * @type {string}
     * @memberof DockDto
     */
    snapInId?: string | null;
}
/**
 * 
 * @export
 * @interface DockInstDto
 */
export interface DockInstDto {
    /**
     * 
     * @type {string}
     * @memberof DockInstDto
     */
    number?: string;
    /**
     * 
     * @type {string}
     * @memberof DockInstDto
     */
    typeId?: string;
    /**
     * 
     * @type {string}
     * @memberof DockInstDto
     */
    snapInCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DockInstDto
     */
    positionId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DockInstDto
     */
    snapInId?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DockInstDto
     */
    snapInCodeDeviceSymbols?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof DockInstDto
     */
    snapInStatus?: string | null;
}
/**
 * 
 * @export
 * @interface DockNewDto
 */
export interface DockNewDto {
    /**
     * 
     * @type {string}
     * @memberof DockNewDto
     */
    number?: string;
    /**
     * 
     * @type {string}
     * @memberof DockNewDto
     */
    typeId?: string;
    /**
     * 
     * @type {string}
     * @memberof DockNewDto
     */
    snapInCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DockNewDto
     */
    positionId?: string;
}
/**
 * 
 * @export
 * @interface DockWithZigbeeIdDto
 */
export interface DockWithZigbeeIdDto {
    /**
     * 
     * @type {string}
     * @memberof DockWithZigbeeIdDto
     */
    number?: string;
    /**
     * 
     * @type {string}
     * @memberof DockWithZigbeeIdDto
     */
    typeId?: string;
    /**
     * 
     * @type {string}
     * @memberof DockWithZigbeeIdDto
     */
    snapInCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DockWithZigbeeIdDto
     */
    positionId?: string;
    /**
     * 
     * @type {string}
     * @memberof DockWithZigbeeIdDto
     */
    snapInId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DockWithZigbeeIdDto
     */
    zigbeeId?: string | null;
}
/**
 * 
 * @export
 * @interface EnergyConsumption
 */
export interface EnergyConsumption {
    /**
     * 
     * @type {number}
     * @memberof EnergyConsumption
     */
    energy?: number | null;
}
/**
 * 
 * @export
 * @interface EntityOfObjectId
 */
export interface EntityOfObjectId {
    /**
     * 
     * @type {ObjectId}
     * @memberof EntityOfObjectId
     */
    id?: ObjectId;
    /**
     * 
     * @type {string}
     * @memberof EntityOfObjectId
     */
    validationRuleSets?: string;
}
/**
 * 
 * @export
 * @interface EntityWithVersionOfObjectId
 */
export interface EntityWithVersionOfObjectId {
    /**
     * 
     * @type {ObjectId}
     * @memberof EntityWithVersionOfObjectId
     */
    id?: ObjectId;
    /**
     * 
     * @type {string}
     * @memberof EntityWithVersionOfObjectId
     */
    validationRuleSets?: string;
    /**
     * 
     * @type {number}
     * @memberof EntityWithVersionOfObjectId
     */
    version?: number;
}
/**
 * 
 * @export
 * @interface EntityWithVersionOfObjectIdAllOf
 */
export interface EntityWithVersionOfObjectIdAllOf {
    /**
     * 
     * @type {number}
     * @memberof EntityWithVersionOfObjectIdAllOf
     */
    version?: number;
}
/**
 * 
 * @export
 * @interface HomeOwnerDto
 */
export interface HomeOwnerDto {
    /**
     * 
     * @type {string}
     * @memberof HomeOwnerDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HomeOwnerDto
     */
    uniqueUserId?: string;
    /**
     * 
     * @type {number}
     * @memberof HomeOwnerDto
     */
    authorizationType?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof HomeOwnerDto
     */
    locations?: Array<string>;
}
/**
 * 
 * @export
 * @interface HomeOwnerLocationsDto
 */
export interface HomeOwnerLocationsDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof HomeOwnerLocationsDto
     */
    locations?: Array<string>;
}
/**
 * 
 * @export
 * @interface HomeOwnerNewDto
 */
export interface HomeOwnerNewDto {
    /**
     * 
     * @type {string}
     * @memberof HomeOwnerNewDto
     */
    uniqueUserId?: string;
    /**
     * 
     * @type {number}
     * @memberof HomeOwnerNewDto
     */
    authorizationType?: number;
}
/**
 * 
 * @export
 * @interface LoacationAddressDetailsDto
 */
export interface LoacationAddressDetailsDto {
    /**
     * 
     * @type {string}
     * @memberof LoacationAddressDetailsDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof LoacationAddressDetailsDto
     */
    lotNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof LoacationAddressDetailsDto
     */
    typeId?: string;
    /**
     * 
     * @type {string}
     * @memberof LoacationAddressDetailsDto
     */
    ownerFirstName?: string;
    /**
     * 
     * @type {string}
     * @memberof LoacationAddressDetailsDto
     */
    ownerLastName?: string;
    /**
     * 
     * @type {string}
     * @memberof LoacationAddressDetailsDto
     */
    ownerPhone?: string;
    /**
     * 
     * @type {string}
     * @memberof LoacationAddressDetailsDto
     */
    ownerEmail?: string;
}
/**
 * 
 * @export
 * @interface LocationBcbDto
 */
export interface LocationBcbDto {
    /**
     * 
     * @type {string}
     * @memberof LocationBcbDto
     */
    bcbId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LocationBcbDto
     */
    disconnected?: boolean;
}
/**
 * 
 * @export
 * @interface LocationBcbInstDto
 */
export interface LocationBcbInstDto {
    /**
     * 
     * @type {string}
     * @memberof LocationBcbInstDto
     */
    bcbId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LocationBcbInstDto
     */
    disconnected?: boolean;
}
/**
 * 
 * @export
 * @interface LocationConfigurationDto
 */
export interface LocationConfigurationDto {
    /**
     * 
     * @type {string}
     * @memberof LocationConfigurationDto
     */
    ssid?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationConfigurationDto
     */
    wiFiPassword?: string;
}
/**
 * 
 * @export
 * @interface LocationConfigurationSnapshotBasicDto
 */
export interface LocationConfigurationSnapshotBasicDto {
    /**
     * 
     * @type {string}
     * @memberof LocationConfigurationSnapshotBasicDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationConfigurationSnapshotBasicDto
     */
    locationId?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationConfigurationSnapshotBasicDto
     */
    creationDateTime?: string;
}
/**
 * 
 * @export
 * @interface LocationConfigurationSnapshotDto
 */
export interface LocationConfigurationSnapshotDto {
    /**
     * 
     * @type {string}
     * @memberof LocationConfigurationSnapshotDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationConfigurationSnapshotDto
     */
    locationId?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationConfigurationSnapshotDto
     */
    creationDateTime?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationConfigurationSnapshotDto
     */
    id?: string;
    /**
     * 
     * @type {Array<RoomWithDocksDto>}
     * @memberof LocationConfigurationSnapshotDto
     */
    rooms?: Array<RoomWithDocksDto>;
    /**
     * 
     * @type {Array<ConnectionConfigurationDto>}
     * @memberof LocationConfigurationSnapshotDto
     */
    connectionConfigurations?: Array<ConnectionConfigurationDto>;
}
/**
 * 
 * @export
 * @interface LocationConfigurationSnapshotDtoAllOf
 */
export interface LocationConfigurationSnapshotDtoAllOf {
    /**
     * 
     * @type {string}
     * @memberof LocationConfigurationSnapshotDtoAllOf
     */
    id?: string;
    /**
     * 
     * @type {Array<RoomWithDocksDto>}
     * @memberof LocationConfigurationSnapshotDtoAllOf
     */
    rooms?: Array<RoomWithDocksDto>;
    /**
     * 
     * @type {Array<ConnectionConfigurationDto>}
     * @memberof LocationConfigurationSnapshotDtoAllOf
     */
    connectionConfigurations?: Array<ConnectionConfigurationDto>;
}
/**
 * 
 * @export
 * @interface LocationConfigurationSnapshotHomeOwnerDto
 */
export interface LocationConfigurationSnapshotHomeOwnerDto {
    /**
     * 
     * @type {string}
     * @memberof LocationConfigurationSnapshotHomeOwnerDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationConfigurationSnapshotHomeOwnerDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationConfigurationSnapshotHomeOwnerDto
     */
    locationId?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationConfigurationSnapshotHomeOwnerDto
     */
    creationDateTime?: string | null;
}
/**
 * 
 * @export
 * @interface LocationDataDto
 */
export interface LocationDataDto {
    /**
     * 
     * @type {SnapInsDataDto}
     * @memberof LocationDataDto
     */
    snapInsData?: SnapInsDataDto;
    /**
     * 
     * @type {LoacationAddressDetailsDto}
     * @memberof LocationDataDto
     */
    location?: LoacationAddressDetailsDto;
}
/**
 * 
 * @export
 * @interface LocationDto
 */
export interface LocationDto {
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    locationName?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    lotNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    locationTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    bcbConnectedStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    insertDate?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    addressCity?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    addressStreet?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    addressHouseNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    addressPostalCode?: string;
    /**
     * 
     * @type {Array<LocationInstallerDto>}
     * @memberof LocationDto
     */
    installers?: Array<LocationInstallerDto>;
    /**
     * 
     * @type {Array<LocationFileDto>}
     * @memberof LocationDto
     */
    files?: Array<LocationFileDto>;
    /**
     * 
     * @type {Array<LocationBcbDto>}
     * @memberof LocationDto
     */
    assignedBcbs?: Array<LocationBcbDto>;
    /**
     * 
     * @type {LocationConfigurationDto}
     * @memberof LocationDto
     */
    locationConfiguration?: LocationConfigurationDto | null;
    /**
     * 
     * @type {DeviceTypeConfigurationDefaultDto}
     * @memberof LocationDto
     */
    deviceTypeConfigurationDefault?: DeviceTypeConfigurationDefaultDto | null;
    /**
     * 
     * @type {Array<ConnectionConfigurationDto>}
     * @memberof LocationDto
     */
    connectionConfigurations?: Array<ConnectionConfigurationDto>;
}
/**
 * 
 * @export
 * @interface LocationFileDto
 */
export interface LocationFileDto {
    /**
     * 
     * @type {string}
     * @memberof LocationFileDto
     */
    blobId?: string;
    /**
     * 
     * @type {number}
     * @memberof LocationFileDto
     */
    fileType?: number;
    /**
     * 
     * @type {string}
     * @memberof LocationFileDto
     */
    fileName?: string;
    /**
     * 
     * @type {number}
     * @memberof LocationFileDto
     */
    fileLength?: number;
    /**
     * 
     * @type {string}
     * @memberof LocationFileDto
     */
    contentType?: string;
}
/**
 * 
 * @export
 * @interface LocationGridDto
 */
export interface LocationGridDto {
    /**
     * 
     * @type {string}
     * @memberof LocationGridDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationGridDto
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationGridDto
     */
    locationName?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationGridDto
     */
    bcbConnectedStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationGridDto
     */
    insertDate?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationGridDto
     */
    addressCity?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationGridDto
     */
    addressStreet?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationGridDto
     */
    addressHouseNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationGridDto
     */
    addressPostalCode?: string;
    /**
     * 
     * @type {Array<LocationInstallerDto>}
     * @memberof LocationGridDto
     */
    installers?: Array<LocationInstallerDto>;
}
/**
 * 
 * @export
 * @interface LocationInstDto
 */
export interface LocationInstDto {
    /**
     * 
     * @type {string}
     * @memberof LocationInstDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationInstDto
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationInstDto
     */
    bcbConnectedStatus?: string;
    /**
     * 
     * @type {Array<LocationBcbInstDto>}
     * @memberof LocationInstDto
     */
    assignedBcbs?: Array<LocationBcbInstDto>;
    /**
     * 
     * @type {Array<RoomInstDto>}
     * @memberof LocationInstDto
     */
    rooms?: Array<RoomInstDto>;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof LocationInstDto
     */
    snapInStatuses?: { [key: string]: number; };
}
/**
 * 
 * @export
 * @interface LocationInstallerDto
 */
export interface LocationInstallerDto {
    /**
     * 
     * @type {string}
     * @memberof LocationInstallerDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationInstallerDto
     */
    givenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationInstallerDto
     */
    surname?: string | null;
}
/**
 * 
 * @export
 * @interface LocationLevelPowerConsumptionDto
 */
export interface LocationLevelPowerConsumptionDto {
    /**
     * 
     * @type {string}
     * @memberof LocationLevelPowerConsumptionDto
     */
    locationId?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationLevelPowerConsumptionDto
     */
    name?: string;
    /**
     * 
     * @type {OldPowerState}
     * @memberof LocationLevelPowerConsumptionDto
     */
    locationPowerMeasurments?: OldPowerState;
    /**
     * 
     * @type {Array<RoomLevelPowerConsumptionDto>}
     * @memberof LocationLevelPowerConsumptionDto
     */
    rooms?: Array<RoomLevelPowerConsumptionDto>;
}
/**
 * 
 * @export
 * @interface LocationNewDto
 */
export interface LocationNewDto {
    /**
     * 
     * @type {string}
     * @memberof LocationNewDto
     */
    locationName?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationNewDto
     */
    lotNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationNewDto
     */
    locationTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationNewDto
     */
    addressCity?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationNewDto
     */
    addressStreet?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationNewDto
     */
    addressHouseNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationNewDto
     */
    addressPostalCode?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LocationNewDto
     */
    installers?: Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum LocationStatusEnum {
    Draft = 'Draft',
    Pending = 'Pending',
    Install = 'Install',
    Operational = 'Operational',
    Maintenance = 'Maintenance',
    Suspended = 'Suspended',
    Stopped = 'Stopped'
}

/**
 * 
 * @export
 * @interface LotLookupResponse
 */
export interface LotLookupResponse {
    /**
     * 
     * @type {string}
     * @memberof LotLookupResponse
     */
    lotNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof LotLookupResponse
     */
    locationId?: string;
}
/**
 * 
 * @export
 * @interface NewSceneDto
 */
export interface NewSceneDto {
    /**
     * 
     * @type {Array<SceneActionDto>}
     * @memberof NewSceneDto
     */
    actions?: Array<SceneActionDto>;
    /**
     * 
     * @type {string}
     * @memberof NewSceneDto
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof NewSceneDto
     */
    enabled?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof NewSceneDto
     */
    roomIds?: Array<string>;
}
/**
 * Represents an ObjectId (see also BsonObjectId).
 * @export
 * @interface ObjectId
 */
export interface ObjectId {
    /**
     * Gets the timestamp.
     * @type {number}
     * @memberof ObjectId
     */
    Timestamp?: number;
    /**
     * Gets the machine.
     * @type {number}
     * @memberof ObjectId
     * @deprecated
     */
    Machine?: number;
    /**
     * Gets the PID.
     * @type {number}
     * @memberof ObjectId
     * @deprecated
     */
    Pid?: number;
    /**
     * Gets the increment.
     * @type {number}
     * @memberof ObjectId
     * @deprecated
     */
    Increment?: number;
    /**
     * Gets the creation time (derived from the timestamp).
     * @type {string}
     * @memberof ObjectId
     */
    CreationTime?: string;
}
/**
 * 
 * @export
 * @interface OldPowerState
 */
export interface OldPowerState {
    /**
     * 
     * @type {PowerStateEnum}
     * @memberof OldPowerState
     */
    state?: PowerStateEnum | null;
    /**
     * 
     * @type {PowerConsumption}
     * @memberof OldPowerState
     */
    powerConsumption?: PowerConsumption | null;
    /**
     * 
     * @type {EnergyConsumption}
     * @memberof OldPowerState
     */
    energyConsumption?: EnergyConsumption | null;
}
/**
 * 
 * @export
 * @interface PagedResultOfHomeOwnerDto
 */
export interface PagedResultOfHomeOwnerDto {
    /**
     * 
     * @type {Array<HomeOwnerDto>}
     * @memberof PagedResultOfHomeOwnerDto
     */
    data?: Array<HomeOwnerDto>;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfHomeOwnerDto
     */
    recordsTotalNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfHomeOwnerDto
     */
    pageSize?: number;
}
/**
 * 
 * @export
 * @interface PagedResultOfLocationConfigurationSnapshotBasicDto
 */
export interface PagedResultOfLocationConfigurationSnapshotBasicDto {
    /**
     * 
     * @type {Array<LocationConfigurationSnapshotBasicDto>}
     * @memberof PagedResultOfLocationConfigurationSnapshotBasicDto
     */
    data?: Array<LocationConfigurationSnapshotBasicDto>;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfLocationConfigurationSnapshotBasicDto
     */
    recordsTotalNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfLocationConfigurationSnapshotBasicDto
     */
    pageSize?: number;
}
/**
 * 
 * @export
 * @interface PagedResultOfLocationConfigurationSnapshotHomeOwnerDto
 */
export interface PagedResultOfLocationConfigurationSnapshotHomeOwnerDto {
    /**
     * 
     * @type {Array<LocationConfigurationSnapshotHomeOwnerDto>}
     * @memberof PagedResultOfLocationConfigurationSnapshotHomeOwnerDto
     */
    data?: Array<LocationConfigurationSnapshotHomeOwnerDto>;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfLocationConfigurationSnapshotHomeOwnerDto
     */
    recordsTotalNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfLocationConfigurationSnapshotHomeOwnerDto
     */
    pageSize?: number;
}
/**
 * 
 * @export
 * @interface PagedResultOfLocationGridDto
 */
export interface PagedResultOfLocationGridDto {
    /**
     * 
     * @type {Array<LocationGridDto>}
     * @memberof PagedResultOfLocationGridDto
     */
    data?: Array<LocationGridDto>;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfLocationGridDto
     */
    recordsTotalNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfLocationGridDto
     */
    pageSize?: number;
}
/**
 * 
 * @export
 * @interface PagedResultOfLocationLevelPowerConsumptionDto
 */
export interface PagedResultOfLocationLevelPowerConsumptionDto {
    /**
     * 
     * @type {Array<LocationLevelPowerConsumptionDto>}
     * @memberof PagedResultOfLocationLevelPowerConsumptionDto
     */
    data?: Array<LocationLevelPowerConsumptionDto>;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfLocationLevelPowerConsumptionDto
     */
    recordsTotalNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfLocationLevelPowerConsumptionDto
     */
    pageSize?: number;
}
/**
 * 
 * @export
 * @interface PagedResultOfSnapInProductGridDto
 */
export interface PagedResultOfSnapInProductGridDto {
    /**
     * 
     * @type {Array<SnapInProductGridDto>}
     * @memberof PagedResultOfSnapInProductGridDto
     */
    data?: Array<SnapInProductGridDto>;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfSnapInProductGridDto
     */
    recordsTotalNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfSnapInProductGridDto
     */
    pageSize?: number;
}
/**
 * 
 * @export
 * @interface PagedResultOfUserDto
 */
export interface PagedResultOfUserDto {
    /**
     * 
     * @type {Array<UserDto>}
     * @memberof PagedResultOfUserDto
     */
    data?: Array<UserDto>;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfUserDto
     */
    recordsTotalNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfUserDto
     */
    pageSize?: number;
}
/**
 * 
 * @export
 * @interface PowerConsumption
 */
export interface PowerConsumption {
    /**
     * 
     * @type {number}
     * @memberof PowerConsumption
     */
    current?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PowerConsumption
     */
    power?: number | null;
}
/**
 * 
 * @export
 * @interface PowerConsumptionAllOf
 */
export interface PowerConsumptionAllOf {
    /**
     * 
     * @type {number}
     * @memberof PowerConsumptionAllOf
     */
    current?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PowerConsumptionAllOf
     */
    power?: number | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum PowerStateEnum {
    Unknown = 'UNKNOWN',
    On = 'ON',
    Off = 'OFF'
}

/**
 * 
 * @export
 * @interface ProblemDetails
 */
export interface ProblemDetails {
    [key: string]: any | any;

    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    title?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProblemDetails
     */
    status?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    detail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    instance?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ProblemDetails
     */
    extensions?: { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface RoomDto
 */
export interface RoomDto {
    /**
     * 
     * @type {string}
     * @memberof RoomDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof RoomDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof RoomDto
     */
    typeId?: string;
}
/**
 * 
 * @export
 * @interface RoomInstDto
 */
export interface RoomInstDto {
    /**
     * 
     * @type {string}
     * @memberof RoomInstDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof RoomInstDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof RoomInstDto
     */
    typeId?: string;
    /**
     * 
     * @type {Array<DockInstDto>}
     * @memberof RoomInstDto
     */
    docks?: Array<DockInstDto>;
}
/**
 * 
 * @export
 * @interface RoomLevelPowerConsumptionDto
 */
export interface RoomLevelPowerConsumptionDto {
    /**
     * 
     * @type {string}
     * @memberof RoomLevelPowerConsumptionDto
     */
    roomName?: string;
    /**
     * 
     * @type {string}
     * @memberof RoomLevelPowerConsumptionDto
     */
    typeId?: string;
    /**
     * 
     * @type {string}
     * @memberof RoomLevelPowerConsumptionDto
     */
    roomId?: string;
    /**
     * 
     * @type {EnergyConsumption}
     * @memberof RoomLevelPowerConsumptionDto
     */
    roomEnergyConsumption?: EnergyConsumption;
    /**
     * 
     * @type {PowerConsumption}
     * @memberof RoomLevelPowerConsumptionDto
     */
    roomPowerConsumption?: PowerConsumption;
    /**
     * 
     * @type {EnergyConsumption}
     * @memberof RoomLevelPowerConsumptionDto
     */
    relayEnergyConsumption?: EnergyConsumption;
    /**
     * 
     * @type {PowerConsumption}
     * @memberof RoomLevelPowerConsumptionDto
     */
    relayPowerConsumption?: PowerConsumption;
    /**
     * 
     * @type {EnergyConsumption}
     * @memberof RoomLevelPowerConsumptionDto
     */
    smartEnergyConsumption?: EnergyConsumption;
    /**
     * 
     * @type {PowerConsumption}
     * @memberof RoomLevelPowerConsumptionDto
     */
    smartPowerConsumption?: PowerConsumption;
    /**
     * 
     * @type {Array<DeviceLevelPowerConsumptionDto>}
     * @memberof RoomLevelPowerConsumptionDto
     */
    devices?: Array<DeviceLevelPowerConsumptionDto>;
    /**
     * 
     * @type {number}
     * @memberof RoomLevelPowerConsumptionDto
     */
    workingDevicesNumber?: number;
}
/**
 * 
 * @export
 * @interface RoomNewDto
 */
export interface RoomNewDto {
    /**
     * 
     * @type {string}
     * @memberof RoomNewDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof RoomNewDto
     */
    typeId?: string;
}
/**
 * 
 * @export
 * @interface RoomWithDocksDto
 */
export interface RoomWithDocksDto {
    /**
     * 
     * @type {string}
     * @memberof RoomWithDocksDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof RoomWithDocksDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof RoomWithDocksDto
     */
    typeId?: string;
    /**
     * 
     * @type {Array<DockDto>}
     * @memberof RoomWithDocksDto
     */
    docks?: Array<DockDto>;
}
/**
 * 
 * @export
 * @interface RoomWithDocksDtoAllOf
 */
export interface RoomWithDocksDtoAllOf {
    /**
     * 
     * @type {Array<DockDto>}
     * @memberof RoomWithDocksDtoAllOf
     */
    docks?: Array<DockDto>;
}
/**
 * 
 * @export
 * @interface SceneActionDto
 */
export interface SceneActionDto {
    /**
     * 
     * @type {string}
     * @memberof SceneActionDto
     */
    dockNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof SceneActionDto
     */
    deviceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof SceneActionDto
     */
    action?: string;
    /**
     * 
     * @type {any}
     * @memberof SceneActionDto
     */
    actionParameters?: any | null;
}
/**
 * 
 * @export
 * @interface SceneDto
 */
export interface SceneDto {
    /**
     * 
     * @type {Array<SceneActionDto>}
     * @memberof SceneDto
     */
    actions?: Array<SceneActionDto>;
    /**
     * 
     * @type {string}
     * @memberof SceneDto
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof SceneDto
     */
    version?: number;
    /**
     * 
     * @type {string}
     * @memberof SceneDto
     */
    locationId?: string;
    /**
     * 
     * @type {string}
     * @memberof SceneDto
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SceneDto
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SceneDto
     */
    modificationTimestamp?: string;
    /**
     * 
     * @type {string}
     * @memberof SceneDto
     */
    modificationVersion?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SceneDto
     */
    roomIds?: Array<string>;
}
/**
 * 
 * @export
 * @interface SnapInProductDto
 */
export interface SnapInProductDto {
    /**
     * 
     * @type {string}
     * @memberof SnapInProductDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SnapInProductDto
     */
    serialNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SnapInProductDto
     */
    snapInCode?: string;
    /**
     * 
     * @type {string}
     * @memberof SnapInProductDto
     */
    macAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof SnapInProductDto
     */
    zigbeeId?: string;
    /**
     * 
     * @type {string}
     * @memberof SnapInProductDto
     */
    snapInStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof SnapInProductDto
     */
    locationId?: string | null;
}
/**
 * 
 * @export
 * @interface SnapInProductGridDto
 */
export interface SnapInProductGridDto {
    /**
     * 
     * @type {string}
     * @memberof SnapInProductGridDto
     */
    serialNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SnapInProductGridDto
     */
    snapInCode?: string;
    /**
     * 
     * @type {string}
     * @memberof SnapInProductGridDto
     */
    macAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SnapInProductGridDto
     */
    zigbeeId?: string;
    /**
     * 
     * @type {SnapInStatusEnum}
     * @memberof SnapInProductGridDto
     */
    snapInStatus?: SnapInStatusEnum;
}
/**
 * 
 * @export
 * @interface SnapInProductNewDto
 */
export interface SnapInProductNewDto {
    /**
     * 
     * @type {string}
     * @memberof SnapInProductNewDto
     */
    serialNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SnapInProductNewDto
     */
    snapInCode?: string;
    /**
     * 
     * @type {string}
     * @memberof SnapInProductNewDto
     */
    macAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SnapInProductNewDto
     */
    zigbeeId?: string | null;
}
/**
 * 
 * @export
 * @interface SnapInStateDataDto
 */
export interface SnapInStateDataDto {
    /**
     * 
     * @type {string}
     * @memberof SnapInStateDataDto
     */
    zigbeeId?: string | null;
    /**
     * 
     * @type {Array<StateDto>}
     * @memberof SnapInStateDataDto
     */
    states?: Array<StateDto> | null;
    /**
     * 
     * @type {Array<DeviceStateDataDto>}
     * @memberof SnapInStateDataDto
     */
    devices?: Array<DeviceStateDataDto> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum SnapInStatusEnum {
    ToBeInstalled = 'ToBeInstalled',
    InstalledNotDetected = 'InstalledNotDetected',
    Detected = 'Detected',
    UnderTesting = 'UnderTesting',
    Tested = 'Tested',
    Error = 'Error'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum SnapInStatusEnum2 {
    ToBeInstalled = 'ToBeInstalled',
    InstalledNotDetected = 'InstalledNotDetected',
    Detected = 'Detected',
    UnderTesting = 'UnderTesting',
    Tested = 'Tested',
    Error = 'Error'
}

/**
 * 
 * @export
 * @interface SnapInTypeDto
 */
export interface SnapInTypeDto {
    /**
     * 
     * @type {string}
     * @memberof SnapInTypeDto
     */
    symbol?: string;
    /**
     * 
     * @type {string}
     * @memberof SnapInTypeDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SnapInTypeDto
     */
    snapInCodeDockTypeSymbolValue?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SnapInTypeDto
     */
    snapInCodeDockPositionSymbols?: Array<string>;
}
/**
 * 
 * @export
 * @interface SnapInsDataDto
 */
export interface SnapInsDataDto {
    /**
     * 
     * @type {number}
     * @memberof SnapInsDataDto
     */
    snapInsAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof SnapInsDataDto
     */
    onlineSnapInsAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof SnapInsDataDto
     */
    snapInsReadyForUpdate?: number;
}
/**
 * 
 * @export
 * @interface StateDto
 */
export interface StateDto {
    /**
     * 
     * @type {any}
     * @memberof StateDto
     */
    data?: any | null;
    /**
     * 
     * @type {string}
     * @memberof StateDto
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface SwitchConfigurationDefault
 */
export interface SwitchConfigurationDefault {
    /**
     * 
     * @type {number}
     * @memberof SwitchConfigurationDefault
     */
    shortPressTimeMs?: number;
    /**
     * 
     * @type {number}
     * @memberof SwitchConfigurationDefault
     */
    longPressTimeMs?: number;
    /**
     * 
     * @type {number}
     * @memberof SwitchConfigurationDefault
     */
    numberOfPresses?: number;
}
/**
 * 
 * @export
 * @interface SwitchConfigurationDefaultDto
 */
export interface SwitchConfigurationDefaultDto {
    /**
     * 
     * @type {number}
     * @memberof SwitchConfigurationDefaultDto
     */
    shortPressTimeMs?: number;
    /**
     * 
     * @type {number}
     * @memberof SwitchConfigurationDefaultDto
     */
    longPressTimeMs?: number;
    /**
     * 
     * @type {number}
     * @memberof SwitchConfigurationDefaultDto
     */
    numberOfPresses?: number;
}
/**
 * 
 * @export
 * @interface UpdateSceneDto
 */
export interface UpdateSceneDto {
    /**
     * 
     * @type {Array<SceneActionDto>}
     * @memberof UpdateSceneDto
     */
    actions?: Array<SceneActionDto>;
    /**
     * 
     * @type {string}
     * @memberof UpdateSceneDto
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSceneDto
     */
    enabled?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateSceneDto
     */
    roomIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateSceneDto
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateSceneDto
     */
    version?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateSceneDto
     */
    modificationTimestamp?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSceneDto
     */
    modificationVersion?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateSceneDtoAllOf
 */
export interface UpdateSceneDtoAllOf {
    /**
     * 
     * @type {string}
     * @memberof UpdateSceneDtoAllOf
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateSceneDtoAllOf
     */
    version?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateSceneDtoAllOf
     */
    modificationTimestamp?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSceneDtoAllOf
     */
    modificationVersion?: string | null;
}
/**
 * 
 * @export
 * @interface UserDto
 */
export interface UserDto {
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    givenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    surname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    mobilePhone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    mail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    companyName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    disabled?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserDto
     */
    userRoleList?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof UserDto
     */
    version?: number;
}
/**
 * 
 * @export
 * @interface UserLookupResponse
 */
export interface UserLookupResponse {
    /**
     * 
     * @type {string}
     * @memberof UserLookupResponse
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserLookupResponse
     */
    givenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserLookupResponse
     */
    surname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserLookupResponse
     */
    companyName?: string | null;
}
/**
 * 
 * @export
 * @interface UserNewDto
 */
export interface UserNewDto {
    /**
     * 
     * @type {string}
     * @memberof UserNewDto
     */
    userName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserNewDto
     */
    givenName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserNewDto
     */
    surname?: string;
    /**
     * 
     * @type {string}
     * @memberof UserNewDto
     */
    mobilePhone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserNewDto
     */
    companyName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserNewDto
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof UserNewDto
     */
    mail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserNewDto
     */
    userRoleList?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface ZigbeeSettingsDto
 */
export interface ZigbeeSettingsDto {
    /**
     * 
     * @type {number}
     * @memberof ZigbeeSettingsDto
     */
    channel?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ZigbeeSettingsDto
     */
    panId?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ZigbeeSettingsDto
     */
    networkKey?: Array<number> | null;
}

/**
 * AuthorizationApi - axios parameter creator
 * @export
 */
export const AuthorizationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Authorization request
         * @param {AuthorizationRequest} authorizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizationPost: async (authorizationRequest: AuthorizationRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorizationRequest' is not null or undefined
            assertParamExists('authorizationPost', 'authorizationRequest', authorizationRequest)
            const localVarPath = `/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authorizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get new token based on previous token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizationRefreshToken: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthorizationApi - functional programming interface
 * @export
 */
export const AuthorizationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthorizationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Authorization request
         * @param {AuthorizationRequest} authorizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authorizationPost(authorizationRequest: AuthorizationRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthorizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authorizationPost(authorizationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get new token based on previous token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authorizationRefreshToken(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthorizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authorizationRefreshToken(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthorizationApi - factory interface
 * @export
 */
export const AuthorizationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthorizationApiFp(configuration)
    return {
        /**
         * 
         * @summary Authorization request
         * @param {AuthorizationRequest} authorizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizationPost(authorizationRequest: AuthorizationRequest, options?: any): AxiosPromise<AuthorizationResponse> {
            return localVarFp.authorizationPost(authorizationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get new token based on previous token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizationRefreshToken(options?: any): AxiosPromise<AuthorizationResponse> {
            return localVarFp.authorizationRefreshToken(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthorizationApi - object-oriented interface
 * @export
 * @class AuthorizationApi
 * @extends {BaseAPI}
 */
export class AuthorizationApi extends BaseAPI {
    /**
     * 
     * @summary Authorization request
     * @param {AuthorizationRequest} authorizationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public authorizationPost(authorizationRequest: AuthorizationRequest, options?: any) {
        return AuthorizationApiFp(this.configuration).authorizationPost(authorizationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get new token based on previous token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public authorizationRefreshToken(options?: any) {
        return AuthorizationApiFp(this.configuration).authorizationRefreshToken(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BcbApi - axios parameter creator
 * @export
 */
export const BcbApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} bcbId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bcbGetBcbStatus: async (bcbId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bcbId' is not null or undefined
            assertParamExists('bcbGetBcbStatus', 'bcbId', bcbId)
            const localVarPath = `/Bcb/status/{bcbId}`
                .replace(`{${"bcbId"}}`, encodeURIComponent(String(bcbId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unassigned BCBs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bcbGetUnassignedBcbs: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/Bcb/unassigned`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BcbApi - functional programming interface
 * @export
 */
export const BcbApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BcbApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} bcbId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bcbGetBcbStatus(bcbId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bcbGetBcbStatus(bcbId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Unassigned BCBs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bcbGetUnassignedBcbs(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BcbUnassignedDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bcbGetUnassignedBcbs(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BcbApi - factory interface
 * @export
 */
export const BcbApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BcbApiFp(configuration)
    return {
        /**
         * 
         * @param {string} bcbId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bcbGetBcbStatus(bcbId: string, options?: any): AxiosPromise<DeviceStatusDto> {
            return localVarFp.bcbGetBcbStatus(bcbId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unassigned BCBs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bcbGetUnassignedBcbs(options?: any): AxiosPromise<Array<BcbUnassignedDto>> {
            return localVarFp.bcbGetUnassignedBcbs(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BcbApi - object-oriented interface
 * @export
 * @class BcbApi
 * @extends {BaseAPI}
 */
export class BcbApi extends BaseAPI {
    /**
     * 
     * @param {string} bcbId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BcbApi
     */
    public bcbGetBcbStatus(bcbId: string, options?: any) {
        return BcbApiFp(this.configuration).bcbGetBcbStatus(bcbId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unassigned BCBs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BcbApi
     */
    public bcbGetUnassignedBcbs(options?: any) {
        return BcbApiFp(this.configuration).bcbGetUnassignedBcbs(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ConfigurationApi - axios parameter creator
 * @export
 */
export const ConfigurationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} locationId 
         * @param {ConnectionConfigurationNewDto} connectionConfigurationNewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationAddConnectionConfiguration: async (locationId: string, connectionConfigurationNewDto: ConnectionConfigurationNewDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('configurationAddConnectionConfiguration', 'locationId', locationId)
            // verify required parameter 'connectionConfigurationNewDto' is not null or undefined
            assertParamExists('configurationAddConnectionConfiguration', 'connectionConfigurationNewDto', connectionConfigurationNewDto)
            const localVarPath = `/Configuration/addConnectionConfiguration/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(connectionConfigurationNewDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {LocationConfigurationDto} locationConfigurationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationConfigureLocation: async (locationId: string, locationConfigurationDto: LocationConfigurationDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('configurationConfigureLocation', 'locationId', locationId)
            // verify required parameter 'locationConfigurationDto' is not null or undefined
            assertParamExists('configurationConfigureLocation', 'locationConfigurationDto', locationConfigurationDto)
            const localVarPath = `/Configuration/configureLocation/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(locationConfigurationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} snapInId 
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationConfigureSnapIn: async (snapInId: string, body: any, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'snapInId' is not null or undefined
            assertParamExists('configurationConfigureSnapIn', 'snapInId', snapInId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('configurationConfigureSnapIn', 'body', body)
            const localVarPath = `/Configuration/configureSnapIn/{snapInId}`
                .replace(`{${"snapInId"}}`, encodeURIComponent(String(snapInId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationGetConfigureConnections: async (locationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('configurationGetConfigureConnections', 'locationId', locationId)
            const localVarPath = `/Configuration/configureConnections/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationGetLocationConfiguration: async (locationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('configurationGetLocationConfiguration', 'locationId', locationId)
            const localVarPath = `/Configuration/configureLocation/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Removes connection configuration.
         * @param {string} locationId Given location ID.
         * @param {string} connectionConfigurationId Given connection configuration ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationRemoveConnectionConfiguration: async (locationId: string, connectionConfigurationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('configurationRemoveConnectionConfiguration', 'locationId', locationId)
            // verify required parameter 'connectionConfigurationId' is not null or undefined
            assertParamExists('configurationRemoveConnectionConfiguration', 'connectionConfigurationId', connectionConfigurationId)
            const localVarPath = `/Configuration/removeConnectionConfiguration/{locationId}/{connectionConfigurationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"connectionConfigurationId"}}`, encodeURIComponent(String(connectionConfigurationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {Array<ConnectionConfigurationNewDto>} connectionConfigurationNewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationReplaceConnectionConfigurations: async (locationId: string, connectionConfigurationNewDto: Array<ConnectionConfigurationNewDto>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('configurationReplaceConnectionConfigurations', 'locationId', locationId)
            // verify required parameter 'connectionConfigurationNewDto' is not null or undefined
            assertParamExists('configurationReplaceConnectionConfigurations', 'connectionConfigurationNewDto', connectionConfigurationNewDto)
            const localVarPath = `/Configuration/replaceConnectionConfigurations/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(connectionConfigurationNewDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationSendLocationToBcbs: async (locationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('configurationSendLocationToBcbs', 'locationId', locationId)
            const localVarPath = `/Configuration/sendLocation/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationSetErrorConnection: async (locationId: string, connectionId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('configurationSetErrorConnection', 'locationId', locationId)
            // verify required parameter 'connectionId' is not null or undefined
            assertParamExists('configurationSetErrorConnection', 'connectionId', connectionId)
            const localVarPath = `/Configuration/setErrorConnection/{locationId}/{connectionId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"connectionId"}}`, encodeURIComponent(String(connectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationSetTestedConnection: async (locationId: string, connectionId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('configurationSetTestedConnection', 'locationId', locationId)
            // verify required parameter 'connectionId' is not null or undefined
            assertParamExists('configurationSetTestedConnection', 'connectionId', connectionId)
            const localVarPath = `/Configuration/setTestedConnection/{locationId}/{connectionId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"connectionId"}}`, encodeURIComponent(String(connectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationStartSnapInConfiguration: async (locationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('configurationStartSnapInConfiguration', 'locationId', locationId)
            const localVarPath = `/Configuration/startSnapInConfiguration/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationStopSnapInConfiguration: async (locationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('configurationStopSnapInConfiguration', 'locationId', locationId)
            const localVarPath = `/Configuration/stopSnapInConfiguration/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConfigurationApi - functional programming interface
 * @export
 */
export const ConfigurationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConfigurationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} locationId 
         * @param {ConnectionConfigurationNewDto} connectionConfigurationNewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configurationAddConnectionConfiguration(locationId: string, connectionConfigurationNewDto: ConnectionConfigurationNewDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectionConfigurationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configurationAddConnectionConfiguration(locationId, connectionConfigurationNewDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {LocationConfigurationDto} locationConfigurationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configurationConfigureLocation(locationId: string, locationConfigurationDto: LocationConfigurationDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configurationConfigureLocation(locationId, locationConfigurationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} snapInId 
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configurationConfigureSnapIn(snapInId: string, body: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configurationConfigureSnapIn(snapInId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configurationGetConfigureConnections(locationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConnectionConfigurationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configurationGetConfigureConnections(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configurationGetLocationConfiguration(locationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationConfigurationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configurationGetLocationConfiguration(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Removes connection configuration.
         * @param {string} locationId Given location ID.
         * @param {string} connectionConfigurationId Given connection configuration ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configurationRemoveConnectionConfiguration(locationId: string, connectionConfigurationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConnectionConfigurationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configurationRemoveConnectionConfiguration(locationId, connectionConfigurationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {Array<ConnectionConfigurationNewDto>} connectionConfigurationNewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configurationReplaceConnectionConfigurations(locationId: string, connectionConfigurationNewDto: Array<ConnectionConfigurationNewDto>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConnectionConfigurationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configurationReplaceConnectionConfigurations(locationId, connectionConfigurationNewDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configurationSendLocationToBcbs(locationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configurationSendLocationToBcbs(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configurationSetErrorConnection(locationId: string, connectionId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configurationSetErrorConnection(locationId, connectionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configurationSetTestedConnection(locationId: string, connectionId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configurationSetTestedConnection(locationId, connectionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configurationStartSnapInConfiguration(locationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configurationStartSnapInConfiguration(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configurationStopSnapInConfiguration(locationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configurationStopSnapInConfiguration(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ConfigurationApi - factory interface
 * @export
 */
export const ConfigurationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConfigurationApiFp(configuration)
    return {
        /**
         * 
         * @param {string} locationId 
         * @param {ConnectionConfigurationNewDto} connectionConfigurationNewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationAddConnectionConfiguration(locationId: string, connectionConfigurationNewDto: ConnectionConfigurationNewDto, options?: any): AxiosPromise<ConnectionConfigurationDto> {
            return localVarFp.configurationAddConnectionConfiguration(locationId, connectionConfigurationNewDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} locationId 
         * @param {LocationConfigurationDto} locationConfigurationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationConfigureLocation(locationId: string, locationConfigurationDto: LocationConfigurationDto, options?: any): AxiosPromise<any> {
            return localVarFp.configurationConfigureLocation(locationId, locationConfigurationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} snapInId 
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationConfigureSnapIn(snapInId: string, body: any, options?: any): AxiosPromise<any> {
            return localVarFp.configurationConfigureSnapIn(snapInId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationGetConfigureConnections(locationId: string, options?: any): AxiosPromise<Array<ConnectionConfigurationDto>> {
            return localVarFp.configurationGetConfigureConnections(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationGetLocationConfiguration(locationId: string, options?: any): AxiosPromise<LocationConfigurationDto> {
            return localVarFp.configurationGetLocationConfiguration(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Removes connection configuration.
         * @param {string} locationId Given location ID.
         * @param {string} connectionConfigurationId Given connection configuration ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationRemoveConnectionConfiguration(locationId: string, connectionConfigurationId: string, options?: any): AxiosPromise<Array<ConnectionConfigurationDto>> {
            return localVarFp.configurationRemoveConnectionConfiguration(locationId, connectionConfigurationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} locationId 
         * @param {Array<ConnectionConfigurationNewDto>} connectionConfigurationNewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationReplaceConnectionConfigurations(locationId: string, connectionConfigurationNewDto: Array<ConnectionConfigurationNewDto>, options?: any): AxiosPromise<Array<ConnectionConfigurationDto>> {
            return localVarFp.configurationReplaceConnectionConfigurations(locationId, connectionConfigurationNewDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationSendLocationToBcbs(locationId: string, options?: any): AxiosPromise<any> {
            return localVarFp.configurationSendLocationToBcbs(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationSetErrorConnection(locationId: string, connectionId: string, options?: any): AxiosPromise<any> {
            return localVarFp.configurationSetErrorConnection(locationId, connectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationSetTestedConnection(locationId: string, connectionId: string, options?: any): AxiosPromise<any> {
            return localVarFp.configurationSetTestedConnection(locationId, connectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationStartSnapInConfiguration(locationId: string, options?: any): AxiosPromise<any> {
            return localVarFp.configurationStartSnapInConfiguration(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationStopSnapInConfiguration(locationId: string, options?: any): AxiosPromise<any> {
            return localVarFp.configurationStopSnapInConfiguration(locationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConfigurationApi - object-oriented interface
 * @export
 * @class ConfigurationApi
 * @extends {BaseAPI}
 */
export class ConfigurationApi extends BaseAPI {
    /**
     * 
     * @param {string} locationId 
     * @param {ConnectionConfigurationNewDto} connectionConfigurationNewDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    public configurationAddConnectionConfiguration(locationId: string, connectionConfigurationNewDto: ConnectionConfigurationNewDto, options?: any) {
        return ConfigurationApiFp(this.configuration).configurationAddConnectionConfiguration(locationId, connectionConfigurationNewDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} locationId 
     * @param {LocationConfigurationDto} locationConfigurationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    public configurationConfigureLocation(locationId: string, locationConfigurationDto: LocationConfigurationDto, options?: any) {
        return ConfigurationApiFp(this.configuration).configurationConfigureLocation(locationId, locationConfigurationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} snapInId 
     * @param {any} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    public configurationConfigureSnapIn(snapInId: string, body: any, options?: any) {
        return ConfigurationApiFp(this.configuration).configurationConfigureSnapIn(snapInId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    public configurationGetConfigureConnections(locationId: string, options?: any) {
        return ConfigurationApiFp(this.configuration).configurationGetConfigureConnections(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    public configurationGetLocationConfiguration(locationId: string, options?: any) {
        return ConfigurationApiFp(this.configuration).configurationGetLocationConfiguration(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Removes connection configuration.
     * @param {string} locationId Given location ID.
     * @param {string} connectionConfigurationId Given connection configuration ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    public configurationRemoveConnectionConfiguration(locationId: string, connectionConfigurationId: string, options?: any) {
        return ConfigurationApiFp(this.configuration).configurationRemoveConnectionConfiguration(locationId, connectionConfigurationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} locationId 
     * @param {Array<ConnectionConfigurationNewDto>} connectionConfigurationNewDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    public configurationReplaceConnectionConfigurations(locationId: string, connectionConfigurationNewDto: Array<ConnectionConfigurationNewDto>, options?: any) {
        return ConfigurationApiFp(this.configuration).configurationReplaceConnectionConfigurations(locationId, connectionConfigurationNewDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    public configurationSendLocationToBcbs(locationId: string, options?: any) {
        return ConfigurationApiFp(this.configuration).configurationSendLocationToBcbs(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} locationId 
     * @param {string} connectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    public configurationSetErrorConnection(locationId: string, connectionId: string, options?: any) {
        return ConfigurationApiFp(this.configuration).configurationSetErrorConnection(locationId, connectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} locationId 
     * @param {string} connectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    public configurationSetTestedConnection(locationId: string, connectionId: string, options?: any) {
        return ConfigurationApiFp(this.configuration).configurationSetTestedConnection(locationId, connectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    public configurationStartSnapInConfiguration(locationId: string, options?: any) {
        return ConfigurationApiFp(this.configuration).configurationStartSnapInConfiguration(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    public configurationStopSnapInConfiguration(locationId: string, options?: any) {
        return ConfigurationApiFp(this.configuration).configurationStopSnapInConfiguration(locationId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ConfigurationDefaultApi - axios parameter creator
 * @export
 */
export const ConfigurationDefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} configurationDefaultName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationDefaultGetConfigurationDefault: async (configurationDefaultName: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'configurationDefaultName' is not null or undefined
            assertParamExists('configurationDefaultGetConfigurationDefault', 'configurationDefaultName', configurationDefaultName)
            const localVarPath = `/ConfigurationDefault/getConfigurationDefault/{configurationDefaultName}`
                .replace(`{${"configurationDefaultName"}}`, encodeURIComponent(String(configurationDefaultName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConfigurationDefaultApi - functional programming interface
 * @export
 */
export const ConfigurationDefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConfigurationDefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} configurationDefaultName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configurationDefaultGetConfigurationDefault(configurationDefaultName: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceTypeConfigurationDefault>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configurationDefaultGetConfigurationDefault(configurationDefaultName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ConfigurationDefaultApi - factory interface
 * @export
 */
export const ConfigurationDefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConfigurationDefaultApiFp(configuration)
    return {
        /**
         * 
         * @param {string} configurationDefaultName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationDefaultGetConfigurationDefault(configurationDefaultName: string, options?: any): AxiosPromise<DeviceTypeConfigurationDefault> {
            return localVarFp.configurationDefaultGetConfigurationDefault(configurationDefaultName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConfigurationDefaultApi - object-oriented interface
 * @export
 * @class ConfigurationDefaultApi
 * @extends {BaseAPI}
 */
export class ConfigurationDefaultApi extends BaseAPI {
    /**
     * 
     * @param {string} configurationDefaultName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationDefaultApi
     */
    public configurationDefaultGetConfigurationDefault(configurationDefaultName: string, options?: any) {
        return ConfigurationDefaultApiFp(this.configuration).configurationDefaultGetConfigurationDefault(configurationDefaultName, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DeviceConfigurationApi - axios parameter creator
 * @export
 */
export const DeviceConfigurationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} locationId 
         * @param {DeviceConfigurationDto} deviceConfigurationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceConfigurationConfigureDevice: async (locationId: string, deviceConfigurationDto: DeviceConfigurationDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('deviceConfigurationConfigureDevice', 'locationId', locationId)
            // verify required parameter 'deviceConfigurationDto' is not null or undefined
            assertParamExists('deviceConfigurationConfigureDevice', 'deviceConfigurationDto', deviceConfigurationDto)
            const localVarPath = `/DeviceConfiguration/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deviceConfigurationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceConfigurationGetDeviceConfiguration: async (locationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('deviceConfigurationGetDeviceConfiguration', 'locationId', locationId)
            const localVarPath = `/DeviceConfiguration/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeviceConfigurationApi - functional programming interface
 * @export
 */
export const DeviceConfigurationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeviceConfigurationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} locationId 
         * @param {DeviceConfigurationDto} deviceConfigurationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deviceConfigurationConfigureDevice(locationId: string, deviceConfigurationDto: DeviceConfigurationDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deviceConfigurationConfigureDevice(locationId, deviceConfigurationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deviceConfigurationGetDeviceConfiguration(locationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceConfigurationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deviceConfigurationGetDeviceConfiguration(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DeviceConfigurationApi - factory interface
 * @export
 */
export const DeviceConfigurationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeviceConfigurationApiFp(configuration)
    return {
        /**
         * 
         * @param {string} locationId 
         * @param {DeviceConfigurationDto} deviceConfigurationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceConfigurationConfigureDevice(locationId: string, deviceConfigurationDto: DeviceConfigurationDto, options?: any): AxiosPromise<any> {
            return localVarFp.deviceConfigurationConfigureDevice(locationId, deviceConfigurationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceConfigurationGetDeviceConfiguration(locationId: string, options?: any): AxiosPromise<DeviceConfigurationDto> {
            return localVarFp.deviceConfigurationGetDeviceConfiguration(locationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeviceConfigurationApi - object-oriented interface
 * @export
 * @class DeviceConfigurationApi
 * @extends {BaseAPI}
 */
export class DeviceConfigurationApi extends BaseAPI {
    /**
     * 
     * @param {string} locationId 
     * @param {DeviceConfigurationDto} deviceConfigurationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceConfigurationApi
     */
    public deviceConfigurationConfigureDevice(locationId: string, deviceConfigurationDto: DeviceConfigurationDto, options?: any) {
        return DeviceConfigurationApiFp(this.configuration).deviceConfigurationConfigureDevice(locationId, deviceConfigurationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceConfigurationApi
     */
    public deviceConfigurationGetDeviceConfiguration(locationId: string, options?: any) {
        return DeviceConfigurationApiFp(this.configuration).deviceConfigurationGetDeviceConfiguration(locationId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DeviceStateApi - axios parameter creator
 * @export
 */
export const DeviceStateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get device states for locationId. It will use assigned BCBs to correlate data from devices.
         * @param {string} locationId Location Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceStateGetDeviceStatesForLocation: async (locationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('deviceStateGetDeviceStatesForLocation', 'locationId', locationId)
            const localVarPath = `/DeviceState/{locationId}/deviceStates`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns power consumption report for all rooms within given location.
         * @param {string} [criteriaLocationId] 
         * @param {string} [orderBy] 
         * @param {boolean} [descending] 
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceStateGetLocationPowerConsumption: async (criteriaLocationId?: string, orderBy?: string, descending?: boolean, pageNumber?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/DeviceState/locationPowerConsumption`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (criteriaLocationId !== undefined) {
                localVarQueryParameter['Criteria.LocationId'] = criteriaLocationId;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['OrderBy'] = orderBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['Descending'] = descending;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns power consumption report for all devices within given room in the location.
         * @param {string} locationId 
         * @param {string} [criteriaRoomId] 
         * @param {string} [orderBy] 
         * @param {boolean} [descending] 
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceStateGetRoomPowerConsumption: async (locationId: string, criteriaRoomId?: string, orderBy?: string, descending?: boolean, pageNumber?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('deviceStateGetRoomPowerConsumption', 'locationId', locationId)
            const localVarPath = `/DeviceState/{locationId}/roomPowerConsumption`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (criteriaRoomId !== undefined) {
                localVarQueryParameter['Criteria.RoomId'] = criteriaRoomId;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['OrderBy'] = orderBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['Descending'] = descending;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send control action to device
         * @param {string} locationId 
         * @param {DeviceActionDto} deviceActionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceStateSetDeviceAction: async (locationId: string, deviceActionDto: DeviceActionDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('deviceStateSetDeviceAction', 'locationId', locationId)
            // verify required parameter 'deviceActionDto' is not null or undefined
            assertParamExists('deviceStateSetDeviceAction', 'deviceActionDto', deviceActionDto)
            const localVarPath = `/DeviceState/{locationId}/deviceState`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deviceActionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeviceStateApi - functional programming interface
 * @export
 */
export const DeviceStateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeviceStateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get device states for locationId. It will use assigned BCBs to correlate data from devices.
         * @param {string} locationId Location Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deviceStateGetDeviceStatesForLocation(locationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SnapInStateDataDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deviceStateGetDeviceStatesForLocation(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns power consumption report for all rooms within given location.
         * @param {string} [criteriaLocationId] 
         * @param {string} [orderBy] 
         * @param {boolean} [descending] 
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deviceStateGetLocationPowerConsumption(criteriaLocationId?: string, orderBy?: string, descending?: boolean, pageNumber?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfLocationLevelPowerConsumptionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deviceStateGetLocationPowerConsumption(criteriaLocationId, orderBy, descending, pageNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns power consumption report for all devices within given room in the location.
         * @param {string} locationId 
         * @param {string} [criteriaRoomId] 
         * @param {string} [orderBy] 
         * @param {boolean} [descending] 
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deviceStateGetRoomPowerConsumption(locationId: string, criteriaRoomId?: string, orderBy?: string, descending?: boolean, pageNumber?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomLevelPowerConsumptionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deviceStateGetRoomPowerConsumption(locationId, criteriaRoomId, orderBy, descending, pageNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Send control action to device
         * @param {string} locationId 
         * @param {DeviceActionDto} deviceActionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deviceStateSetDeviceAction(locationId: string, deviceActionDto: DeviceActionDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deviceStateSetDeviceAction(locationId, deviceActionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DeviceStateApi - factory interface
 * @export
 */
export const DeviceStateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeviceStateApiFp(configuration)
    return {
        /**
         * 
         * @summary Get device states for locationId. It will use assigned BCBs to correlate data from devices.
         * @param {string} locationId Location Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceStateGetDeviceStatesForLocation(locationId: string, options?: any): AxiosPromise<Array<SnapInStateDataDto>> {
            return localVarFp.deviceStateGetDeviceStatesForLocation(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns power consumption report for all rooms within given location.
         * @param {string} [criteriaLocationId] 
         * @param {string} [orderBy] 
         * @param {boolean} [descending] 
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceStateGetLocationPowerConsumption(criteriaLocationId?: string, orderBy?: string, descending?: boolean, pageNumber?: number, options?: any): AxiosPromise<PagedResultOfLocationLevelPowerConsumptionDto> {
            return localVarFp.deviceStateGetLocationPowerConsumption(criteriaLocationId, orderBy, descending, pageNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns power consumption report for all devices within given room in the location.
         * @param {string} locationId 
         * @param {string} [criteriaRoomId] 
         * @param {string} [orderBy] 
         * @param {boolean} [descending] 
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceStateGetRoomPowerConsumption(locationId: string, criteriaRoomId?: string, orderBy?: string, descending?: boolean, pageNumber?: number, options?: any): AxiosPromise<RoomLevelPowerConsumptionDto> {
            return localVarFp.deviceStateGetRoomPowerConsumption(locationId, criteriaRoomId, orderBy, descending, pageNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send control action to device
         * @param {string} locationId 
         * @param {DeviceActionDto} deviceActionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceStateSetDeviceAction(locationId: string, deviceActionDto: DeviceActionDto, options?: any): AxiosPromise<void> {
            return localVarFp.deviceStateSetDeviceAction(locationId, deviceActionDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeviceStateApi - object-oriented interface
 * @export
 * @class DeviceStateApi
 * @extends {BaseAPI}
 */
export class DeviceStateApi extends BaseAPI {
    /**
     * 
     * @summary Get device states for locationId. It will use assigned BCBs to correlate data from devices.
     * @param {string} locationId Location Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceStateApi
     */
    public deviceStateGetDeviceStatesForLocation(locationId: string, options?: any) {
        return DeviceStateApiFp(this.configuration).deviceStateGetDeviceStatesForLocation(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns power consumption report for all rooms within given location.
     * @param {string} [criteriaLocationId] 
     * @param {string} [orderBy] 
     * @param {boolean} [descending] 
     * @param {number} [pageNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceStateApi
     */
    public deviceStateGetLocationPowerConsumption(criteriaLocationId?: string, orderBy?: string, descending?: boolean, pageNumber?: number, options?: any) {
        return DeviceStateApiFp(this.configuration).deviceStateGetLocationPowerConsumption(criteriaLocationId, orderBy, descending, pageNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns power consumption report for all devices within given room in the location.
     * @param {string} locationId 
     * @param {string} [criteriaRoomId] 
     * @param {string} [orderBy] 
     * @param {boolean} [descending] 
     * @param {number} [pageNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceStateApi
     */
    public deviceStateGetRoomPowerConsumption(locationId: string, criteriaRoomId?: string, orderBy?: string, descending?: boolean, pageNumber?: number, options?: any) {
        return DeviceStateApiFp(this.configuration).deviceStateGetRoomPowerConsumption(locationId, criteriaRoomId, orderBy, descending, pageNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send control action to device
     * @param {string} locationId 
     * @param {DeviceActionDto} deviceActionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceStateApi
     */
    public deviceStateSetDeviceAction(locationId: string, deviceActionDto: DeviceActionDto, options?: any) {
        return DeviceStateApiFp(this.configuration).deviceStateSetDeviceAction(locationId, deviceActionDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DictionaryApi - axios parameter creator
 * @export
 */
export const DictionaryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryGetDeviceTypes: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/Dictionary/deviceTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get key - value list for given dictionary
         * @param {string} dictionary LocationType, Position, RoomType, DockType             
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryGetDict: async (dictionary: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'dictionary' is not null or undefined
            assertParamExists('dictionaryGetDict', 'dictionary', dictionary)
            const localVarPath = `/Dictionary/{dictionary}`
                .replace(`{${"dictionary"}}`, encodeURIComponent(String(dictionary)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryGetSnapInTypes: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/Dictionary/snapInTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DictionaryApi - functional programming interface
 * @export
 */
export const DictionaryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DictionaryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dictionaryGetDeviceTypes(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeviceTypeDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dictionaryGetDeviceTypes(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get key - value list for given dictionary
         * @param {string} dictionary LocationType, Position, RoomType, DockType             
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dictionaryGetDict(dictionary: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dictionaryGetDict(dictionary, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dictionaryGetSnapInTypes(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SnapInTypeDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dictionaryGetSnapInTypes(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DictionaryApi - factory interface
 * @export
 */
export const DictionaryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DictionaryApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryGetDeviceTypes(options?: any): AxiosPromise<Array<DeviceTypeDto>> {
            return localVarFp.dictionaryGetDeviceTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get key - value list for given dictionary
         * @param {string} dictionary LocationType, Position, RoomType, DockType             
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryGetDict(dictionary: string, options?: any): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.dictionaryGetDict(dictionary, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryGetSnapInTypes(options?: any): AxiosPromise<Array<SnapInTypeDto>> {
            return localVarFp.dictionaryGetSnapInTypes(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DictionaryApi - object-oriented interface
 * @export
 * @class DictionaryApi
 * @extends {BaseAPI}
 */
export class DictionaryApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionaryApi
     */
    public dictionaryGetDeviceTypes(options?: any) {
        return DictionaryApiFp(this.configuration).dictionaryGetDeviceTypes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get key - value list for given dictionary
     * @param {string} dictionary LocationType, Position, RoomType, DockType             
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionaryApi
     */
    public dictionaryGetDict(dictionary: string, options?: any) {
        return DictionaryApiFp(this.configuration).dictionaryGetDict(dictionary, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionaryApi
     */
    public dictionaryGetSnapInTypes(options?: any) {
        return DictionaryApiFp(this.configuration).dictionaryGetSnapInTypes(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DockApi - axios parameter creator
 * @export
 */
export const DockApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} locationId 
         * @param {string} roomId 
         * @param {DockNewDto} dockNewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockAddDock: async (locationId: string, roomId: string, dockNewDto: DockNewDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('dockAddDock', 'locationId', locationId)
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('dockAddDock', 'roomId', roomId)
            // verify required parameter 'dockNewDto' is not null or undefined
            assertParamExists('dockAddDock', 'dockNewDto', dockNewDto)
            const localVarPath = `/Dock/{locationId}/{roomId}/addDock`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dockNewDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockGetDocks: async (locationId: string, roomId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('dockGetDocks', 'locationId', locationId)
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('dockGetDocks', 'roomId', roomId)
            const localVarPath = `/Dock/{locationId}/{roomId}/getDocks`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} dockNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockRemoveDock: async (locationId: string, dockNumber: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('dockRemoveDock', 'locationId', locationId)
            // verify required parameter 'dockNumber' is not null or undefined
            assertParamExists('dockRemoveDock', 'dockNumber', dockNumber)
            const localVarPath = `/Dock/{locationId}/deleteDock/{dockNumber}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"dockNumber"}}`, encodeURIComponent(String(dockNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {DockDto} dockDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockUpdateDock: async (locationId: string, dockDto: DockDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('dockUpdateDock', 'locationId', locationId)
            // verify required parameter 'dockDto' is not null or undefined
            assertParamExists('dockUpdateDock', 'dockDto', dockDto)
            const localVarPath = `/Dock/{locationId}/updateDock`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dockDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DockApi - functional programming interface
 * @export
 */
export const DockApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DockApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} locationId 
         * @param {string} roomId 
         * @param {DockNewDto} dockNewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dockAddDock(locationId: string, roomId: string, dockNewDto: DockNewDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DockDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dockAddDock(locationId, roomId, dockNewDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dockGetDocks(locationId: string, roomId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DockWithZigbeeIdDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dockGetDocks(locationId, roomId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} dockNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dockRemoveDock(locationId: string, dockNumber: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dockRemoveDock(locationId, dockNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {DockDto} dockDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dockUpdateDock(locationId: string, dockDto: DockDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DockDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dockUpdateDock(locationId, dockDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DockApi - factory interface
 * @export
 */
export const DockApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DockApiFp(configuration)
    return {
        /**
         * 
         * @param {string} locationId 
         * @param {string} roomId 
         * @param {DockNewDto} dockNewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockAddDock(locationId: string, roomId: string, dockNewDto: DockNewDto, options?: any): AxiosPromise<DockDto> {
            return localVarFp.dockAddDock(locationId, roomId, dockNewDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockGetDocks(locationId: string, roomId: string, options?: any): AxiosPromise<Array<DockWithZigbeeIdDto>> {
            return localVarFp.dockGetDocks(locationId, roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} dockNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockRemoveDock(locationId: string, dockNumber: string, options?: any): AxiosPromise<void> {
            return localVarFp.dockRemoveDock(locationId, dockNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} locationId 
         * @param {DockDto} dockDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockUpdateDock(locationId: string, dockDto: DockDto, options?: any): AxiosPromise<DockDto> {
            return localVarFp.dockUpdateDock(locationId, dockDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DockApi - object-oriented interface
 * @export
 * @class DockApi
 * @extends {BaseAPI}
 */
export class DockApi extends BaseAPI {
    /**
     * 
     * @param {string} locationId 
     * @param {string} roomId 
     * @param {DockNewDto} dockNewDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockApi
     */
    public dockAddDock(locationId: string, roomId: string, dockNewDto: DockNewDto, options?: any) {
        return DockApiFp(this.configuration).dockAddDock(locationId, roomId, dockNewDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} locationId 
     * @param {string} roomId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockApi
     */
    public dockGetDocks(locationId: string, roomId: string, options?: any) {
        return DockApiFp(this.configuration).dockGetDocks(locationId, roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} locationId 
     * @param {string} dockNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockApi
     */
    public dockRemoveDock(locationId: string, dockNumber: string, options?: any) {
        return DockApiFp(this.configuration).dockRemoveDock(locationId, dockNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} locationId 
     * @param {DockDto} dockDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockApi
     */
    public dockUpdateDock(locationId: string, dockDto: DockDto, options?: any) {
        return DockApiFp(this.configuration).dockUpdateDock(locationId, dockDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EnrollmentApi - axios parameter creator
 * @export
 */
export const EnrollmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentGetEnrollments: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/Enrollment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Provision new device to the cloud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentProvisionDevice: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/Enrollment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnrollmentApi - functional programming interface
 * @export
 */
export const EnrollmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EnrollmentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enrollmentGetEnrollments(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<any>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enrollmentGetEnrollments(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Provision new device to the cloud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enrollmentProvisionDevice(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enrollmentProvisionDevice(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EnrollmentApi - factory interface
 * @export
 */
export const EnrollmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EnrollmentApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentGetEnrollments(options?: any): AxiosPromise<Array<any>> {
            return localVarFp.enrollmentGetEnrollments(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Provision new device to the cloud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentProvisionDevice(options?: any): AxiosPromise<object> {
            return localVarFp.enrollmentProvisionDevice(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EnrollmentApi - object-oriented interface
 * @export
 * @class EnrollmentApi
 * @extends {BaseAPI}
 */
export class EnrollmentApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrollmentApi
     */
    public enrollmentGetEnrollments(options?: any) {
        return EnrollmentApiFp(this.configuration).enrollmentGetEnrollments(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Provision new device to the cloud
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrollmentApi
     */
    public enrollmentProvisionDevice(options?: any) {
        return EnrollmentApiFp(this.configuration).enrollmentProvisionDevice(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ErrorApi - axios parameter creator
 * @export
 */
export const ErrorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorError: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/error`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ErrorApi - functional programming interface
 * @export
 */
export const ErrorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ErrorApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async errorError(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.errorError(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ErrorApi - factory interface
 * @export
 */
export const ErrorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ErrorApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorError(options?: any): AxiosPromise<any> {
            return localVarFp.errorError(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ErrorApi - object-oriented interface
 * @export
 * @class ErrorApi
 * @extends {BaseAPI}
 */
export class ErrorApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ErrorApi
     */
    public errorError(options?: any) {
        return ErrorApiFp(this.configuration).errorError(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * HomeOwnerApi - axios parameter creator
 * @export
 */
export const HomeOwnerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Adds new Home Owner.
         * @param {HomeOwnerNewDto} homeOwnerNewDto New HomeOwner data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeOwnerAddHomeOwner: async (homeOwnerNewDto: HomeOwnerNewDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'homeOwnerNewDto' is not null or undefined
            assertParamExists('homeOwnerAddHomeOwner', 'homeOwnerNewDto', homeOwnerNewDto)
            const localVarPath = `/HomeOwner/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(homeOwnerNewDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Assigns location to Home Owner.
         * @param {string} newLocationId New location ID.
         * @param {string} userId User ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeOwnerAddLocationForHomeOwner: async (newLocationId: string, userId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'newLocationId' is not null or undefined
            assertParamExists('homeOwnerAddLocationForHomeOwner', 'newLocationId', newLocationId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('homeOwnerAddLocationForHomeOwner', 'userId', userId)
            const localVarPath = `/HomeOwner/addNewLocation/{newLocationId}/{userId}`
                .replace(`{${"newLocationId"}}`, encodeURIComponent(String(newLocationId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes Home Owner.
         * @param {string} [userId] User ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeOwnerDeleteHomeOwner: async (userId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/HomeOwner/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes location from Home Owner.
         * @param {string} locationId Location ID.
         * @param {string} userId User ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeOwnerDeleteLocationFromHomeOwner: async (locationId: string, userId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('homeOwnerDeleteLocationFromHomeOwner', 'locationId', locationId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('homeOwnerDeleteLocationFromHomeOwner', 'userId', userId)
            const localVarPath = `/HomeOwner/deleteLocation/{locationId}/{userId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets all home owners
         * @param {string} [criteriaId] 
         * @param {number} [criteriaAuthenticationType] 
         * @param {string} [criteriaUniqueUserId] 
         * @param {string} [orderBy] 
         * @param {boolean} [descending] 
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeOwnerGet: async (criteriaId?: string, criteriaAuthenticationType?: number, criteriaUniqueUserId?: string, orderBy?: string, descending?: boolean, pageNumber?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/HomeOwner/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (criteriaId !== undefined) {
                localVarQueryParameter['Criteria.Id'] = criteriaId;
            }

            if (criteriaAuthenticationType !== undefined) {
                localVarQueryParameter['Criteria.AuthenticationType'] = criteriaAuthenticationType;
            }

            if (criteriaUniqueUserId !== undefined) {
                localVarQueryParameter['Criteria.UniqueUserId'] = criteriaUniqueUserId;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['OrderBy'] = orderBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['Descending'] = descending;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get locations for currently logged HO user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeOwnerGetLocations: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/HomeOwner/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HomeOwnerApi - functional programming interface
 * @export
 */
export const HomeOwnerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HomeOwnerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Adds new Home Owner.
         * @param {HomeOwnerNewDto} homeOwnerNewDto New HomeOwner data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async homeOwnerAddHomeOwner(homeOwnerNewDto: HomeOwnerNewDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HomeOwnerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.homeOwnerAddHomeOwner(homeOwnerNewDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Assigns location to Home Owner.
         * @param {string} newLocationId New location ID.
         * @param {string} userId User ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async homeOwnerAddLocationForHomeOwner(newLocationId: string, userId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HomeOwnerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.homeOwnerAddLocationForHomeOwner(newLocationId, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Deletes Home Owner.
         * @param {string} [userId] User ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async homeOwnerDeleteHomeOwner(userId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.homeOwnerDeleteHomeOwner(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Deletes location from Home Owner.
         * @param {string} locationId Location ID.
         * @param {string} userId User ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async homeOwnerDeleteLocationFromHomeOwner(locationId: string, userId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HomeOwnerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.homeOwnerDeleteLocationFromHomeOwner(locationId, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets all home owners
         * @param {string} [criteriaId] 
         * @param {number} [criteriaAuthenticationType] 
         * @param {string} [criteriaUniqueUserId] 
         * @param {string} [orderBy] 
         * @param {boolean} [descending] 
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async homeOwnerGet(criteriaId?: string, criteriaAuthenticationType?: number, criteriaUniqueUserId?: string, orderBy?: string, descending?: boolean, pageNumber?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfHomeOwnerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.homeOwnerGet(criteriaId, criteriaAuthenticationType, criteriaUniqueUserId, orderBy, descending, pageNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get locations for currently logged HO user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async homeOwnerGetLocations(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HomeOwnerLocationsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.homeOwnerGetLocations(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HomeOwnerApi - factory interface
 * @export
 */
export const HomeOwnerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HomeOwnerApiFp(configuration)
    return {
        /**
         * 
         * @summary Adds new Home Owner.
         * @param {HomeOwnerNewDto} homeOwnerNewDto New HomeOwner data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeOwnerAddHomeOwner(homeOwnerNewDto: HomeOwnerNewDto, options?: any): AxiosPromise<HomeOwnerDto> {
            return localVarFp.homeOwnerAddHomeOwner(homeOwnerNewDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Assigns location to Home Owner.
         * @param {string} newLocationId New location ID.
         * @param {string} userId User ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeOwnerAddLocationForHomeOwner(newLocationId: string, userId: string, options?: any): AxiosPromise<HomeOwnerDto> {
            return localVarFp.homeOwnerAddLocationForHomeOwner(newLocationId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes Home Owner.
         * @param {string} [userId] User ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeOwnerDeleteHomeOwner(userId?: string, options?: any): AxiosPromise<any> {
            return localVarFp.homeOwnerDeleteHomeOwner(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes location from Home Owner.
         * @param {string} locationId Location ID.
         * @param {string} userId User ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeOwnerDeleteLocationFromHomeOwner(locationId: string, userId: string, options?: any): AxiosPromise<HomeOwnerDto> {
            return localVarFp.homeOwnerDeleteLocationFromHomeOwner(locationId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets all home owners
         * @param {string} [criteriaId] 
         * @param {number} [criteriaAuthenticationType] 
         * @param {string} [criteriaUniqueUserId] 
         * @param {string} [orderBy] 
         * @param {boolean} [descending] 
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeOwnerGet(criteriaId?: string, criteriaAuthenticationType?: number, criteriaUniqueUserId?: string, orderBy?: string, descending?: boolean, pageNumber?: number, options?: any): AxiosPromise<PagedResultOfHomeOwnerDto> {
            return localVarFp.homeOwnerGet(criteriaId, criteriaAuthenticationType, criteriaUniqueUserId, orderBy, descending, pageNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get locations for currently logged HO user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeOwnerGetLocations(options?: any): AxiosPromise<HomeOwnerLocationsDto> {
            return localVarFp.homeOwnerGetLocations(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HomeOwnerApi - object-oriented interface
 * @export
 * @class HomeOwnerApi
 * @extends {BaseAPI}
 */
export class HomeOwnerApi extends BaseAPI {
    /**
     * 
     * @summary Adds new Home Owner.
     * @param {HomeOwnerNewDto} homeOwnerNewDto New HomeOwner data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HomeOwnerApi
     */
    public homeOwnerAddHomeOwner(homeOwnerNewDto: HomeOwnerNewDto, options?: any) {
        return HomeOwnerApiFp(this.configuration).homeOwnerAddHomeOwner(homeOwnerNewDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Assigns location to Home Owner.
     * @param {string} newLocationId New location ID.
     * @param {string} userId User ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HomeOwnerApi
     */
    public homeOwnerAddLocationForHomeOwner(newLocationId: string, userId: string, options?: any) {
        return HomeOwnerApiFp(this.configuration).homeOwnerAddLocationForHomeOwner(newLocationId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes Home Owner.
     * @param {string} [userId] User ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HomeOwnerApi
     */
    public homeOwnerDeleteHomeOwner(userId?: string, options?: any) {
        return HomeOwnerApiFp(this.configuration).homeOwnerDeleteHomeOwner(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes location from Home Owner.
     * @param {string} locationId Location ID.
     * @param {string} userId User ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HomeOwnerApi
     */
    public homeOwnerDeleteLocationFromHomeOwner(locationId: string, userId: string, options?: any) {
        return HomeOwnerApiFp(this.configuration).homeOwnerDeleteLocationFromHomeOwner(locationId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets all home owners
     * @param {string} [criteriaId] 
     * @param {number} [criteriaAuthenticationType] 
     * @param {string} [criteriaUniqueUserId] 
     * @param {string} [orderBy] 
     * @param {boolean} [descending] 
     * @param {number} [pageNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HomeOwnerApi
     */
    public homeOwnerGet(criteriaId?: string, criteriaAuthenticationType?: number, criteriaUniqueUserId?: string, orderBy?: string, descending?: boolean, pageNumber?: number, options?: any) {
        return HomeOwnerApiFp(this.configuration).homeOwnerGet(criteriaId, criteriaAuthenticationType, criteriaUniqueUserId, orderBy, descending, pageNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get locations for currently logged HO user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HomeOwnerApi
     */
    public homeOwnerGetLocations(options?: any) {
        return HomeOwnerApiFp(this.configuration).homeOwnerGetLocations(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * HomeOwnerAuthenticationApi - axios parameter creator
 * @export
 */
export const HomeOwnerAuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Generates proper login token.
         * @param {AuthorizationTypeEnum} authorizationType Type of authorization. Now only \&quot;Internal\&quot; (1) is valid. AuthorizationTypeEnum             
         * @param {AuthorizationRequest} authorizationRequest Request with login data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeOwnerAuthenticationPost: async (authorizationType: AuthorizationTypeEnum, authorizationRequest: AuthorizationRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorizationType' is not null or undefined
            assertParamExists('homeOwnerAuthenticationPost', 'authorizationType', authorizationType)
            // verify required parameter 'authorizationRequest' is not null or undefined
            assertParamExists('homeOwnerAuthenticationPost', 'authorizationRequest', authorizationRequest)
            const localVarPath = `/HomeOwnerAuthentication/login/{authorizationType}`
                .replace(`{${"authorizationType"}}`, encodeURIComponent(String(authorizationType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authorizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HomeOwnerAuthenticationApi - functional programming interface
 * @export
 */
export const HomeOwnerAuthenticationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HomeOwnerAuthenticationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Generates proper login token.
         * @param {AuthorizationTypeEnum} authorizationType Type of authorization. Now only \&quot;Internal\&quot; (1) is valid. AuthorizationTypeEnum             
         * @param {AuthorizationRequest} authorizationRequest Request with login data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async homeOwnerAuthenticationPost(authorizationType: AuthorizationTypeEnum, authorizationRequest: AuthorizationRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthorizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.homeOwnerAuthenticationPost(authorizationType, authorizationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HomeOwnerAuthenticationApi - factory interface
 * @export
 */
export const HomeOwnerAuthenticationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HomeOwnerAuthenticationApiFp(configuration)
    return {
        /**
         * 
         * @summary Generates proper login token.
         * @param {AuthorizationTypeEnum} authorizationType Type of authorization. Now only \&quot;Internal\&quot; (1) is valid. AuthorizationTypeEnum             
         * @param {AuthorizationRequest} authorizationRequest Request with login data.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeOwnerAuthenticationPost(authorizationType: AuthorizationTypeEnum, authorizationRequest: AuthorizationRequest, options?: any): AxiosPromise<AuthorizationResponse> {
            return localVarFp.homeOwnerAuthenticationPost(authorizationType, authorizationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HomeOwnerAuthenticationApi - object-oriented interface
 * @export
 * @class HomeOwnerAuthenticationApi
 * @extends {BaseAPI}
 */
export class HomeOwnerAuthenticationApi extends BaseAPI {
    /**
     * 
     * @summary Generates proper login token.
     * @param {AuthorizationTypeEnum} authorizationType Type of authorization. Now only \&quot;Internal\&quot; (1) is valid. AuthorizationTypeEnum             
     * @param {AuthorizationRequest} authorizationRequest Request with login data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HomeOwnerAuthenticationApi
     */
    public homeOwnerAuthenticationPost(authorizationType: AuthorizationTypeEnum, authorizationRequest: AuthorizationRequest, options?: any) {
        return HomeOwnerAuthenticationApiFp(this.configuration).homeOwnerAuthenticationPost(authorizationType, authorizationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LocationApi - axios parameter creator
 * @export
 */
export const LocationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Assign unassigned BCB to given location
         * @param {string} locationId location locationId
         * @param {string} bcbId unassigned bcb locationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationAssignBcb: async (locationId: string, bcbId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('locationAssignBcb', 'locationId', locationId)
            // verify required parameter 'bcbId' is not null or undefined
            assertParamExists('locationAssignBcb', 'bcbId', bcbId)
            const localVarPath = `/Location/{locationId}/bcbAssign/{bcbId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"bcbId"}}`, encodeURIComponent(String(bcbId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Changes location status
         * @param {string} locationId 
         * @param {LocationStatusEnum} [newStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationChangeLocationStatus: async (locationId: string, newStatus?: LocationStatusEnum, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('locationChangeLocationStatus', 'locationId', locationId)
            const localVarPath = `/Location/{locationId}/changeLocationStatus`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (newStatus !== undefined) {
                localVarQueryParameter['newStatus'] = newStatus;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates new location
         * @param {LocationNewDto} locationNewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationCreateLocation: async (locationNewDto: LocationNewDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationNewDto' is not null or undefined
            assertParamExists('locationCreateLocation', 'locationNewDto', locationNewDto)
            const localVarPath = `/Location`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(locationNewDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} fileBlobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationDeleteFile: async (locationId: string, fileBlobId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('locationDeleteFile', 'locationId', locationId)
            // verify required parameter 'fileBlobId' is not null or undefined
            assertParamExists('locationDeleteFile', 'fileBlobId', fileBlobId)
            const localVarPath = `/Location/{locationId}/deleteFile/{fileBlobId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"fileBlobId"}}`, encodeURIComponent(String(fileBlobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete location if location is in proper status and doesn\'t have assigned snap-ins
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationDeleteLocation: async (locationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('locationDeleteLocation', 'locationId', locationId)
            const localVarPath = `/Location/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete location - use only for testing purposes
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationDeleteLocationTestOnly: async (locationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('locationDeleteLocationTestOnly', 'locationId', locationId)
            const localVarPath = `/Location/{locationId}/testOnly`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Detach assigned BCB from given location
         * @param {string} locationId location locationId
         * @param {string} bcbId assigned bcb locationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationDetachBcb: async (locationId: string, bcbId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('locationDetachBcb', 'locationId', locationId)
            // verify required parameter 'bcbId' is not null or undefined
            assertParamExists('locationDetachBcb', 'bcbId', bcbId)
            const localVarPath = `/Location/{locationId}/bcbDetach/{bcbId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"bcbId"}}`, encodeURIComponent(String(bcbId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download file to given location
         * @param {string} locationId Location locationId
         * @param {string} fileBlobId blob file locationId within location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationDownloadFile: async (locationId: string, fileBlobId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('locationDownloadFile', 'locationId', locationId)
            // verify required parameter 'fileBlobId' is not null or undefined
            assertParamExists('locationDownloadFile', 'fileBlobId', fileBlobId)
            const localVarPath = `/Location/{locationId}/downloadFile/{fileBlobId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"fileBlobId"}}`, encodeURIComponent(String(fileBlobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new location as a copy for location with given locationId
         * @param {string} locationId 
         * @param {number} numberOfCopies Number of copies (default &#x3D; 1)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationDuplicateLocation: async (locationId: string, numberOfCopies: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('locationDuplicateLocation', 'locationId', locationId)
            // verify required parameter 'numberOfCopies' is not null or undefined
            assertParamExists('locationDuplicateLocation', 'numberOfCopies', numberOfCopies)
            const localVarPath = `/Location/{locationId}/duplicate/{numberOfCopies}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"numberOfCopies"}}`, encodeURIComponent(String(numberOfCopies)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get one location by locationId
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationGetLocation: async (locationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('locationGetLocation', 'locationId', locationId)
            const localVarPath = `/Location/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get one location for installer by locationId
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationGetLocationForInstaller: async (locationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('locationGetLocationForInstaller', 'locationId', locationId)
            const localVarPath = `/Location/installer/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get SnapIns statuses from location
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationGetLocationSnapInsStatus: async (locationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('locationGetLocationSnapInsStatus', 'locationId', locationId)
            const localVarPath = `/Location/{locationId}/snapInsStatus`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get locations list for given parameters and sorting criteria. Result is in pages
         * @param {string} [criteriaAddressCity] 
         * @param {string} [criteriaAddressStreet] 
         * @param {string} [criteriaInstaller] 
         * @param {string} [criteriaLocationName] 
         * @param {LocationStatusEnum} [criteriaLocationStatus] 
         * @param {string} [orderBy] 
         * @param {boolean} [descending] 
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationGetLocations: async (criteriaAddressCity?: string, criteriaAddressStreet?: string, criteriaInstaller?: string, criteriaLocationName?: string, criteriaLocationStatus?: LocationStatusEnum, orderBy?: string, descending?: boolean, pageNumber?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/Location`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (criteriaAddressCity !== undefined) {
                localVarQueryParameter['Criteria.AddressCity'] = criteriaAddressCity;
            }

            if (criteriaAddressStreet !== undefined) {
                localVarQueryParameter['Criteria.AddressStreet'] = criteriaAddressStreet;
            }

            if (criteriaInstaller !== undefined) {
                localVarQueryParameter['Criteria.Installer'] = criteriaInstaller;
            }

            if (criteriaLocationName !== undefined) {
                localVarQueryParameter['Criteria.LocationName'] = criteriaLocationName;
            }

            if (criteriaLocationStatus !== undefined) {
                localVarQueryParameter['Criteria.LocationStatus'] = criteriaLocationStatus;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['OrderBy'] = orderBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['Descending'] = descending;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check lot name
         * @param {string} [projectName] 
         * @param {string} [lotPartial] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationLotNameLookup: async (projectName?: string, lotPartial?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/Location/projectName/lotPartial`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (projectName !== undefined) {
                localVarQueryParameter['projectName'] = projectName;
            }

            if (lotPartial !== undefined) {
                localVarQueryParameter['lotPartial'] = lotPartial;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check project name
         * @param {string} [projectName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationProjectNameLookup: async (projectName?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/Location/projectName`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (projectName !== undefined) {
                localVarQueryParameter['projectName'] = projectName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Saves modified location
         * @param {LocationDto} locationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationUpdateLocation: async (locationDto: LocationDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationDto' is not null or undefined
            assertParamExists('locationUpdateLocation', 'locationDto', locationDto)
            const localVarPath = `/Location`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(locationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload files to given location
         * @param {string} locationId Location locationId
         * @param {number} [fileType] 
         * @param {Array<any>} [formFiles] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationUploadFile: async (locationId: string, fileType?: number, formFiles?: Array<any>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('locationUploadFile', 'locationId', locationId)
            const localVarPath = `/Location/{locationId}/uploadFile`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (fileType !== undefined) {
                localVarQueryParameter['fileType'] = fileType;
            }

            if (formFiles) {
                formFiles.forEach((element) => {
                    localVarFormParams.append('formFiles', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationApi - functional programming interface
 * @export
 */
export const LocationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Assign unassigned BCB to given location
         * @param {string} locationId location locationId
         * @param {string} bcbId unassigned bcb locationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationAssignBcb(locationId: string, bcbId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationAssignBcb(locationId, bcbId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Changes location status
         * @param {string} locationId 
         * @param {LocationStatusEnum} [newStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationChangeLocationStatus(locationId: string, newStatus?: LocationStatusEnum, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationChangeLocationStatus(locationId, newStatus, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Creates new location
         * @param {LocationNewDto} locationNewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationCreateLocation(locationNewDto: LocationNewDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationCreateLocation(locationNewDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} fileBlobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationDeleteFile(locationId: string, fileBlobId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationDeleteFile(locationId, fileBlobId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete location if location is in proper status and doesn\'t have assigned snap-ins
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationDeleteLocation(locationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationDeleteLocation(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete location - use only for testing purposes
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationDeleteLocationTestOnly(locationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationDeleteLocationTestOnly(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Detach assigned BCB from given location
         * @param {string} locationId location locationId
         * @param {string} bcbId assigned bcb locationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationDetachBcb(locationId: string, bcbId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationDetachBcb(locationId, bcbId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Download file to given location
         * @param {string} locationId Location locationId
         * @param {string} fileBlobId blob file locationId within location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationDownloadFile(locationId: string, fileBlobId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationDownloadFile(locationId, fileBlobId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create new location as a copy for location with given locationId
         * @param {string} locationId 
         * @param {number} numberOfCopies Number of copies (default &#x3D; 1)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationDuplicateLocation(locationId: string, numberOfCopies: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LocationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationDuplicateLocation(locationId, numberOfCopies, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get one location by locationId
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationGetLocation(locationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationGetLocation(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get one location for installer by locationId
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationGetLocationForInstaller(locationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationInstDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationGetLocationForInstaller(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get SnapIns statuses from location
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationGetLocationSnapInsStatus(locationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationGetLocationSnapInsStatus(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get locations list for given parameters and sorting criteria. Result is in pages
         * @param {string} [criteriaAddressCity] 
         * @param {string} [criteriaAddressStreet] 
         * @param {string} [criteriaInstaller] 
         * @param {string} [criteriaLocationName] 
         * @param {LocationStatusEnum} [criteriaLocationStatus] 
         * @param {string} [orderBy] 
         * @param {boolean} [descending] 
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationGetLocations(criteriaAddressCity?: string, criteriaAddressStreet?: string, criteriaInstaller?: string, criteriaLocationName?: string, criteriaLocationStatus?: LocationStatusEnum, orderBy?: string, descending?: boolean, pageNumber?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfLocationGridDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationGetLocations(criteriaAddressCity, criteriaAddressStreet, criteriaInstaller, criteriaLocationName, criteriaLocationStatus, orderBy, descending, pageNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Check lot name
         * @param {string} [projectName] 
         * @param {string} [lotPartial] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationLotNameLookup(projectName?: string, lotPartial?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LotLookupResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationLotNameLookup(projectName, lotPartial, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Check project name
         * @param {string} [projectName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationProjectNameLookup(projectName?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationProjectNameLookup(projectName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Saves modified location
         * @param {LocationDto} locationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationUpdateLocation(locationDto: LocationDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationUpdateLocation(locationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Upload files to given location
         * @param {string} locationId Location locationId
         * @param {number} [fileType] 
         * @param {Array<any>} [formFiles] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationUploadFile(locationId: string, fileType?: number, formFiles?: Array<any>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationUploadFile(locationId, fileType, formFiles, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LocationApi - factory interface
 * @export
 */
export const LocationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationApiFp(configuration)
    return {
        /**
         * 
         * @summary Assign unassigned BCB to given location
         * @param {string} locationId location locationId
         * @param {string} bcbId unassigned bcb locationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationAssignBcb(locationId: string, bcbId: string, options?: any): AxiosPromise<any> {
            return localVarFp.locationAssignBcb(locationId, bcbId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Changes location status
         * @param {string} locationId 
         * @param {LocationStatusEnum} [newStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationChangeLocationStatus(locationId: string, newStatus?: LocationStatusEnum, options?: any): AxiosPromise<any> {
            return localVarFp.locationChangeLocationStatus(locationId, newStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates new location
         * @param {LocationNewDto} locationNewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationCreateLocation(locationNewDto: LocationNewDto, options?: any): AxiosPromise<LocationDto> {
            return localVarFp.locationCreateLocation(locationNewDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} fileBlobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationDeleteFile(locationId: string, fileBlobId: string, options?: any): AxiosPromise<any> {
            return localVarFp.locationDeleteFile(locationId, fileBlobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete location if location is in proper status and doesn\'t have assigned snap-ins
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationDeleteLocation(locationId: string, options?: any): AxiosPromise<any> {
            return localVarFp.locationDeleteLocation(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete location - use only for testing purposes
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationDeleteLocationTestOnly(locationId: string, options?: any): AxiosPromise<any> {
            return localVarFp.locationDeleteLocationTestOnly(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Detach assigned BCB from given location
         * @param {string} locationId location locationId
         * @param {string} bcbId assigned bcb locationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationDetachBcb(locationId: string, bcbId: string, options?: any): AxiosPromise<any> {
            return localVarFp.locationDetachBcb(locationId, bcbId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download file to given location
         * @param {string} locationId Location locationId
         * @param {string} fileBlobId blob file locationId within location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationDownloadFile(locationId: string, fileBlobId: string, options?: any): AxiosPromise<any> {
            return localVarFp.locationDownloadFile(locationId, fileBlobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create new location as a copy for location with given locationId
         * @param {string} locationId 
         * @param {number} numberOfCopies Number of copies (default &#x3D; 1)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationDuplicateLocation(locationId: string, numberOfCopies: number, options?: any): AxiosPromise<Array<LocationDto>> {
            return localVarFp.locationDuplicateLocation(locationId, numberOfCopies, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get one location by locationId
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationGetLocation(locationId: string, options?: any): AxiosPromise<LocationDto> {
            return localVarFp.locationGetLocation(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get one location for installer by locationId
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationGetLocationForInstaller(locationId: string, options?: any): AxiosPromise<LocationInstDto> {
            return localVarFp.locationGetLocationForInstaller(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get SnapIns statuses from location
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationGetLocationSnapInsStatus(locationId: string, options?: any): AxiosPromise<LocationDataDto> {
            return localVarFp.locationGetLocationSnapInsStatus(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get locations list for given parameters and sorting criteria. Result is in pages
         * @param {string} [criteriaAddressCity] 
         * @param {string} [criteriaAddressStreet] 
         * @param {string} [criteriaInstaller] 
         * @param {string} [criteriaLocationName] 
         * @param {LocationStatusEnum} [criteriaLocationStatus] 
         * @param {string} [orderBy] 
         * @param {boolean} [descending] 
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationGetLocations(criteriaAddressCity?: string, criteriaAddressStreet?: string, criteriaInstaller?: string, criteriaLocationName?: string, criteriaLocationStatus?: LocationStatusEnum, orderBy?: string, descending?: boolean, pageNumber?: number, options?: any): AxiosPromise<PagedResultOfLocationGridDto> {
            return localVarFp.locationGetLocations(criteriaAddressCity, criteriaAddressStreet, criteriaInstaller, criteriaLocationName, criteriaLocationStatus, orderBy, descending, pageNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check lot name
         * @param {string} [projectName] 
         * @param {string} [lotPartial] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationLotNameLookup(projectName?: string, lotPartial?: string, options?: any): AxiosPromise<Array<LotLookupResponse>> {
            return localVarFp.locationLotNameLookup(projectName, lotPartial, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check project name
         * @param {string} [projectName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationProjectNameLookup(projectName?: string, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.locationProjectNameLookup(projectName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Saves modified location
         * @param {LocationDto} locationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationUpdateLocation(locationDto: LocationDto, options?: any): AxiosPromise<LocationDto> {
            return localVarFp.locationUpdateLocation(locationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload files to given location
         * @param {string} locationId Location locationId
         * @param {number} [fileType] 
         * @param {Array<any>} [formFiles] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationUploadFile(locationId: string, fileType?: number, formFiles?: Array<any>, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.locationUploadFile(locationId, fileType, formFiles, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocationApi - object-oriented interface
 * @export
 * @class LocationApi
 * @extends {BaseAPI}
 */
export class LocationApi extends BaseAPI {
    /**
     * 
     * @summary Assign unassigned BCB to given location
     * @param {string} locationId location locationId
     * @param {string} bcbId unassigned bcb locationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public locationAssignBcb(locationId: string, bcbId: string, options?: any) {
        return LocationApiFp(this.configuration).locationAssignBcb(locationId, bcbId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Changes location status
     * @param {string} locationId 
     * @param {LocationStatusEnum} [newStatus] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public locationChangeLocationStatus(locationId: string, newStatus?: LocationStatusEnum, options?: any) {
        return LocationApiFp(this.configuration).locationChangeLocationStatus(locationId, newStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates new location
     * @param {LocationNewDto} locationNewDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public locationCreateLocation(locationNewDto: LocationNewDto, options?: any) {
        return LocationApiFp(this.configuration).locationCreateLocation(locationNewDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} locationId 
     * @param {string} fileBlobId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public locationDeleteFile(locationId: string, fileBlobId: string, options?: any) {
        return LocationApiFp(this.configuration).locationDeleteFile(locationId, fileBlobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete location if location is in proper status and doesn\'t have assigned snap-ins
     * @param {string} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public locationDeleteLocation(locationId: string, options?: any) {
        return LocationApiFp(this.configuration).locationDeleteLocation(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete location - use only for testing purposes
     * @param {string} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public locationDeleteLocationTestOnly(locationId: string, options?: any) {
        return LocationApiFp(this.configuration).locationDeleteLocationTestOnly(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Detach assigned BCB from given location
     * @param {string} locationId location locationId
     * @param {string} bcbId assigned bcb locationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public locationDetachBcb(locationId: string, bcbId: string, options?: any) {
        return LocationApiFp(this.configuration).locationDetachBcb(locationId, bcbId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download file to given location
     * @param {string} locationId Location locationId
     * @param {string} fileBlobId blob file locationId within location
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public locationDownloadFile(locationId: string, fileBlobId: string, options?: any) {
        return LocationApiFp(this.configuration).locationDownloadFile(locationId, fileBlobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create new location as a copy for location with given locationId
     * @param {string} locationId 
     * @param {number} numberOfCopies Number of copies (default &#x3D; 1)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public locationDuplicateLocation(locationId: string, numberOfCopies: number, options?: any) {
        return LocationApiFp(this.configuration).locationDuplicateLocation(locationId, numberOfCopies, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get one location by locationId
     * @param {string} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public locationGetLocation(locationId: string, options?: any) {
        return LocationApiFp(this.configuration).locationGetLocation(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get one location for installer by locationId
     * @param {string} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public locationGetLocationForInstaller(locationId: string, options?: any) {
        return LocationApiFp(this.configuration).locationGetLocationForInstaller(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get SnapIns statuses from location
     * @param {string} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public locationGetLocationSnapInsStatus(locationId: string, options?: any) {
        return LocationApiFp(this.configuration).locationGetLocationSnapInsStatus(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get locations list for given parameters and sorting criteria. Result is in pages
     * @param {string} [criteriaAddressCity] 
     * @param {string} [criteriaAddressStreet] 
     * @param {string} [criteriaInstaller] 
     * @param {string} [criteriaLocationName] 
     * @param {LocationStatusEnum} [criteriaLocationStatus] 
     * @param {string} [orderBy] 
     * @param {boolean} [descending] 
     * @param {number} [pageNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public locationGetLocations(criteriaAddressCity?: string, criteriaAddressStreet?: string, criteriaInstaller?: string, criteriaLocationName?: string, criteriaLocationStatus?: LocationStatusEnum, orderBy?: string, descending?: boolean, pageNumber?: number, options?: any) {
        return LocationApiFp(this.configuration).locationGetLocations(criteriaAddressCity, criteriaAddressStreet, criteriaInstaller, criteriaLocationName, criteriaLocationStatus, orderBy, descending, pageNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check lot name
     * @param {string} [projectName] 
     * @param {string} [lotPartial] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public locationLotNameLookup(projectName?: string, lotPartial?: string, options?: any) {
        return LocationApiFp(this.configuration).locationLotNameLookup(projectName, lotPartial, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check project name
     * @param {string} [projectName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public locationProjectNameLookup(projectName?: string, options?: any) {
        return LocationApiFp(this.configuration).locationProjectNameLookup(projectName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Saves modified location
     * @param {LocationDto} locationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public locationUpdateLocation(locationDto: LocationDto, options?: any) {
        return LocationApiFp(this.configuration).locationUpdateLocation(locationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload files to given location
     * @param {string} locationId Location locationId
     * @param {number} [fileType] 
     * @param {Array<any>} [formFiles] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public locationUploadFile(locationId: string, fileType?: number, formFiles?: Array<any>, options?: any) {
        return LocationApiFp(this.configuration).locationUploadFile(locationId, fileType, formFiles, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LocationConfigurationSnapshotApi - axios parameter creator
 * @export
 */
export const LocationConfigurationSnapshotApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} snapshotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationConfigurationSnapshotDeleteTestOnly: async (snapshotId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'snapshotId' is not null or undefined
            assertParamExists('locationConfigurationSnapshotDeleteTestOnly', 'snapshotId', snapshotId)
            const localVarPath = `/LocationConfigurationSnapshot/delete/{snapshotId}`
                .replace(`{${"snapshotId"}}`, encodeURIComponent(String(snapshotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all snapshots with configuration of locations.
         * @param {string} [criteriaId] 
         * @param {string} [criteriaName] 
         * @param {string} [criteriaLocationId] 
         * @param {string} [criteriaCreationDateTime] 
         * @param {string} [orderBy] 
         * @param {boolean} [descending] 
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationConfigurationSnapshotGet: async (criteriaId?: string, criteriaName?: string, criteriaLocationId?: string, criteriaCreationDateTime?: string, orderBy?: string, descending?: boolean, pageNumber?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/LocationConfigurationSnapshot/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (criteriaId !== undefined) {
                localVarQueryParameter['Criteria.Id'] = criteriaId;
            }

            if (criteriaName !== undefined) {
                localVarQueryParameter['Criteria.Name'] = criteriaName;
            }

            if (criteriaLocationId !== undefined) {
                localVarQueryParameter['Criteria.LocationId'] = criteriaLocationId;
            }

            if (criteriaCreationDateTime !== undefined) {
                localVarQueryParameter['Criteria.CreationDateTime'] = (criteriaCreationDateTime as any instanceof Date) ?
                    (criteriaCreationDateTime as any).toISOString() :
                    criteriaCreationDateTime;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['OrderBy'] = orderBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['Descending'] = descending;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns one snapshot by given ID.
         * @param {string} snapshotId Snapshot ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationConfigurationSnapshotGetById: async (snapshotId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'snapshotId' is not null or undefined
            assertParamExists('locationConfigurationSnapshotGetById', 'snapshotId', snapshotId)
            const localVarPath = `/LocationConfigurationSnapshot/get/{snapshotId}`
                .replace(`{${"snapshotId"}}`, encodeURIComponent(String(snapshotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all snapshots created for given location. Filter data. Location ID.
         * @param {string} locationId 
         * @param {string} [criteriaName] 
         * @param {string} [criteriaCreationDateTime] 
         * @param {string} [orderBy] 
         * @param {boolean} [descending] 
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationConfigurationSnapshotGetByLocation: async (locationId: string, criteriaName?: string, criteriaCreationDateTime?: string, orderBy?: string, descending?: boolean, pageNumber?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('locationConfigurationSnapshotGetByLocation', 'locationId', locationId)
            const localVarPath = `/LocationConfigurationSnapshot/getByLocation/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (criteriaName !== undefined) {
                localVarQueryParameter['Criteria.Name'] = criteriaName;
            }

            if (criteriaCreationDateTime !== undefined) {
                localVarQueryParameter['Criteria.CreationDateTime'] = (criteriaCreationDateTime as any instanceof Date) ?
                    (criteriaCreationDateTime as any).toISOString() :
                    criteriaCreationDateTime;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['OrderBy'] = orderBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['Descending'] = descending;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Restores selected snapshot of configuration saved for location.
         * @param {string} [locationId] 
         * @param {string} [snapshotId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationConfigurationSnapshotRestore: async (locationId?: string, snapshotId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/LocationConfigurationSnapshot/restore`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }

            if (snapshotId !== undefined) {
                localVarQueryParameter['snapshotId'] = snapshotId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates snapshot of configuration in current location.
         * @param {string} locationId Location ID for which snapshot will be taken.
         * @param {string} [name] Optional name of snapshot
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationConfigurationSnapshotSave: async (locationId: string, name?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('locationConfigurationSnapshotSave', 'locationId', locationId)
            const localVarPath = `/LocationConfigurationSnapshot/save/{locationId}/name`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationConfigurationSnapshotApi - functional programming interface
 * @export
 */
export const LocationConfigurationSnapshotApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationConfigurationSnapshotApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} snapshotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationConfigurationSnapshotDeleteTestOnly(snapshotId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationConfigurationSnapshotDeleteTestOnly(snapshotId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all snapshots with configuration of locations.
         * @param {string} [criteriaId] 
         * @param {string} [criteriaName] 
         * @param {string} [criteriaLocationId] 
         * @param {string} [criteriaCreationDateTime] 
         * @param {string} [orderBy] 
         * @param {boolean} [descending] 
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationConfigurationSnapshotGet(criteriaId?: string, criteriaName?: string, criteriaLocationId?: string, criteriaCreationDateTime?: string, orderBy?: string, descending?: boolean, pageNumber?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfLocationConfigurationSnapshotBasicDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationConfigurationSnapshotGet(criteriaId, criteriaName, criteriaLocationId, criteriaCreationDateTime, orderBy, descending, pageNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns one snapshot by given ID.
         * @param {string} snapshotId Snapshot ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationConfigurationSnapshotGetById(snapshotId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationConfigurationSnapshotDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationConfigurationSnapshotGetById(snapshotId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all snapshots created for given location. Filter data. Location ID.
         * @param {string} locationId 
         * @param {string} [criteriaName] 
         * @param {string} [criteriaCreationDateTime] 
         * @param {string} [orderBy] 
         * @param {boolean} [descending] 
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationConfigurationSnapshotGetByLocation(locationId: string, criteriaName?: string, criteriaCreationDateTime?: string, orderBy?: string, descending?: boolean, pageNumber?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfLocationConfigurationSnapshotHomeOwnerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationConfigurationSnapshotGetByLocation(locationId, criteriaName, criteriaCreationDateTime, orderBy, descending, pageNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Restores selected snapshot of configuration saved for location.
         * @param {string} [locationId] 
         * @param {string} [snapshotId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationConfigurationSnapshotRestore(locationId?: string, snapshotId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationConfigurationSnapshotRestore(locationId, snapshotId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Creates snapshot of configuration in current location.
         * @param {string} locationId Location ID for which snapshot will be taken.
         * @param {string} [name] Optional name of snapshot
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationConfigurationSnapshotSave(locationId: string, name?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationConfigurationSnapshotDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationConfigurationSnapshotSave(locationId, name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LocationConfigurationSnapshotApi - factory interface
 * @export
 */
export const LocationConfigurationSnapshotApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationConfigurationSnapshotApiFp(configuration)
    return {
        /**
         * 
         * @param {string} snapshotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationConfigurationSnapshotDeleteTestOnly(snapshotId: string, options?: any): AxiosPromise<any> {
            return localVarFp.locationConfigurationSnapshotDeleteTestOnly(snapshotId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all snapshots with configuration of locations.
         * @param {string} [criteriaId] 
         * @param {string} [criteriaName] 
         * @param {string} [criteriaLocationId] 
         * @param {string} [criteriaCreationDateTime] 
         * @param {string} [orderBy] 
         * @param {boolean} [descending] 
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationConfigurationSnapshotGet(criteriaId?: string, criteriaName?: string, criteriaLocationId?: string, criteriaCreationDateTime?: string, orderBy?: string, descending?: boolean, pageNumber?: number, options?: any): AxiosPromise<PagedResultOfLocationConfigurationSnapshotBasicDto> {
            return localVarFp.locationConfigurationSnapshotGet(criteriaId, criteriaName, criteriaLocationId, criteriaCreationDateTime, orderBy, descending, pageNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns one snapshot by given ID.
         * @param {string} snapshotId Snapshot ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationConfigurationSnapshotGetById(snapshotId: string, options?: any): AxiosPromise<LocationConfigurationSnapshotDto> {
            return localVarFp.locationConfigurationSnapshotGetById(snapshotId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all snapshots created for given location. Filter data. Location ID.
         * @param {string} locationId 
         * @param {string} [criteriaName] 
         * @param {string} [criteriaCreationDateTime] 
         * @param {string} [orderBy] 
         * @param {boolean} [descending] 
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationConfigurationSnapshotGetByLocation(locationId: string, criteriaName?: string, criteriaCreationDateTime?: string, orderBy?: string, descending?: boolean, pageNumber?: number, options?: any): AxiosPromise<PagedResultOfLocationConfigurationSnapshotHomeOwnerDto> {
            return localVarFp.locationConfigurationSnapshotGetByLocation(locationId, criteriaName, criteriaCreationDateTime, orderBy, descending, pageNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Restores selected snapshot of configuration saved for location.
         * @param {string} [locationId] 
         * @param {string} [snapshotId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationConfigurationSnapshotRestore(locationId?: string, snapshotId?: string, options?: any): AxiosPromise<any> {
            return localVarFp.locationConfigurationSnapshotRestore(locationId, snapshotId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates snapshot of configuration in current location.
         * @param {string} locationId Location ID for which snapshot will be taken.
         * @param {string} [name] Optional name of snapshot
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationConfigurationSnapshotSave(locationId: string, name?: string, options?: any): AxiosPromise<LocationConfigurationSnapshotDto> {
            return localVarFp.locationConfigurationSnapshotSave(locationId, name, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocationConfigurationSnapshotApi - object-oriented interface
 * @export
 * @class LocationConfigurationSnapshotApi
 * @extends {BaseAPI}
 */
export class LocationConfigurationSnapshotApi extends BaseAPI {
    /**
     * 
     * @param {string} snapshotId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationConfigurationSnapshotApi
     */
    public locationConfigurationSnapshotDeleteTestOnly(snapshotId: string, options?: any) {
        return LocationConfigurationSnapshotApiFp(this.configuration).locationConfigurationSnapshotDeleteTestOnly(snapshotId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all snapshots with configuration of locations.
     * @param {string} [criteriaId] 
     * @param {string} [criteriaName] 
     * @param {string} [criteriaLocationId] 
     * @param {string} [criteriaCreationDateTime] 
     * @param {string} [orderBy] 
     * @param {boolean} [descending] 
     * @param {number} [pageNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationConfigurationSnapshotApi
     */
    public locationConfigurationSnapshotGet(criteriaId?: string, criteriaName?: string, criteriaLocationId?: string, criteriaCreationDateTime?: string, orderBy?: string, descending?: boolean, pageNumber?: number, options?: any) {
        return LocationConfigurationSnapshotApiFp(this.configuration).locationConfigurationSnapshotGet(criteriaId, criteriaName, criteriaLocationId, criteriaCreationDateTime, orderBy, descending, pageNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns one snapshot by given ID.
     * @param {string} snapshotId Snapshot ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationConfigurationSnapshotApi
     */
    public locationConfigurationSnapshotGetById(snapshotId: string, options?: any) {
        return LocationConfigurationSnapshotApiFp(this.configuration).locationConfigurationSnapshotGetById(snapshotId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all snapshots created for given location. Filter data. Location ID.
     * @param {string} locationId 
     * @param {string} [criteriaName] 
     * @param {string} [criteriaCreationDateTime] 
     * @param {string} [orderBy] 
     * @param {boolean} [descending] 
     * @param {number} [pageNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationConfigurationSnapshotApi
     */
    public locationConfigurationSnapshotGetByLocation(locationId: string, criteriaName?: string, criteriaCreationDateTime?: string, orderBy?: string, descending?: boolean, pageNumber?: number, options?: any) {
        return LocationConfigurationSnapshotApiFp(this.configuration).locationConfigurationSnapshotGetByLocation(locationId, criteriaName, criteriaCreationDateTime, orderBy, descending, pageNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Restores selected snapshot of configuration saved for location.
     * @param {string} [locationId] 
     * @param {string} [snapshotId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationConfigurationSnapshotApi
     */
    public locationConfigurationSnapshotRestore(locationId?: string, snapshotId?: string, options?: any) {
        return LocationConfigurationSnapshotApiFp(this.configuration).locationConfigurationSnapshotRestore(locationId, snapshotId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates snapshot of configuration in current location.
     * @param {string} locationId Location ID for which snapshot will be taken.
     * @param {string} [name] Optional name of snapshot
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationConfigurationSnapshotApi
     */
    public locationConfigurationSnapshotSave(locationId: string, name?: string, options?: any) {
        return LocationConfigurationSnapshotApiFp(this.configuration).locationConfigurationSnapshotSave(locationId, name, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OtaApi - axios parameter creator
 * @export
 */
export const OtaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Forces ota update on devices.
         * @param {string} locationId Location ID.
         * @param {string} bcbId Bcb ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        otaForceOtaUpdate: async (locationId: string, bcbId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('otaForceOtaUpdate', 'locationId', locationId)
            // verify required parameter 'bcbId' is not null or undefined
            assertParamExists('otaForceOtaUpdate', 'bcbId', bcbId)
            const localVarPath = `/Ota/update/force/{locationId}/{bcbId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"bcbId"}}`, encodeURIComponent(String(bcbId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OtaApi - functional programming interface
 * @export
 */
export const OtaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OtaApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Forces ota update on devices.
         * @param {string} locationId Location ID.
         * @param {string} bcbId Bcb ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async otaForceOtaUpdate(locationId: string, bcbId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.otaForceOtaUpdate(locationId, bcbId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OtaApi - factory interface
 * @export
 */
export const OtaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OtaApiFp(configuration)
    return {
        /**
         * 
         * @summary Forces ota update on devices.
         * @param {string} locationId Location ID.
         * @param {string} bcbId Bcb ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        otaForceOtaUpdate(locationId: string, bcbId: string, options?: any): AxiosPromise<void> {
            return localVarFp.otaForceOtaUpdate(locationId, bcbId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OtaApi - object-oriented interface
 * @export
 * @class OtaApi
 * @extends {BaseAPI}
 */
export class OtaApi extends BaseAPI {
    /**
     * 
     * @summary Forces ota update on devices.
     * @param {string} locationId Location ID.
     * @param {string} bcbId Bcb ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OtaApi
     */
    public otaForceOtaUpdate(locationId: string, bcbId: string, options?: any) {
        return OtaApiFp(this.configuration).otaForceOtaUpdate(locationId, bcbId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RoomApi - axios parameter creator
 * @export
 */
export const RoomApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Adds room to location
         * @param {string} locationId 
         * @param {RoomNewDto} roomNewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roomAddRoom: async (locationId: string, roomNewDto: RoomNewDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('roomAddRoom', 'locationId', locationId)
            // verify required parameter 'roomNewDto' is not null or undefined
            assertParamExists('roomAddRoom', 'roomNewDto', roomNewDto)
            const localVarPath = `/Room/{locationId}/addRoom`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(roomNewDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get rooms for given locationId
         * @param {string} locationId ObjectId for the location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roomGetRooms: async (locationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('roomGetRooms', 'locationId', locationId)
            const localVarPath = `/Room/{locationId}/getRooms`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roomRemoveRoom: async (locationId: string, roomId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('roomRemoveRoom', 'locationId', locationId)
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('roomRemoveRoom', 'roomId', roomId)
            const localVarPath = `/Room/{locationId}/deleteRoom/{roomId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update room in location
         * @param {string} locationId 
         * @param {RoomDto} roomDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roomUpdateRoom: async (locationId: string, roomDto: RoomDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('roomUpdateRoom', 'locationId', locationId)
            // verify required parameter 'roomDto' is not null or undefined
            assertParamExists('roomUpdateRoom', 'roomDto', roomDto)
            const localVarPath = `/Room/{locationId}/updateRoom`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(roomDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RoomApi - functional programming interface
 * @export
 */
export const RoomApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RoomApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Adds room to location
         * @param {string} locationId 
         * @param {RoomNewDto} roomNewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roomAddRoom(locationId: string, roomNewDto: RoomNewDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roomAddRoom(locationId, roomNewDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get rooms for given locationId
         * @param {string} locationId ObjectId for the location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roomGetRooms(locationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoomDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roomGetRooms(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roomRemoveRoom(locationId: string, roomId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roomRemoveRoom(locationId, roomId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update room in location
         * @param {string} locationId 
         * @param {RoomDto} roomDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roomUpdateRoom(locationId: string, roomDto: RoomDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roomUpdateRoom(locationId, roomDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RoomApi - factory interface
 * @export
 */
export const RoomApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RoomApiFp(configuration)
    return {
        /**
         * 
         * @summary Adds room to location
         * @param {string} locationId 
         * @param {RoomNewDto} roomNewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roomAddRoom(locationId: string, roomNewDto: RoomNewDto, options?: any): AxiosPromise<string> {
            return localVarFp.roomAddRoom(locationId, roomNewDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get rooms for given locationId
         * @param {string} locationId ObjectId for the location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roomGetRooms(locationId: string, options?: any): AxiosPromise<Array<RoomDto>> {
            return localVarFp.roomGetRooms(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roomRemoveRoom(locationId: string, roomId: string, options?: any): AxiosPromise<any> {
            return localVarFp.roomRemoveRoom(locationId, roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update room in location
         * @param {string} locationId 
         * @param {RoomDto} roomDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roomUpdateRoom(locationId: string, roomDto: RoomDto, options?: any): AxiosPromise<string> {
            return localVarFp.roomUpdateRoom(locationId, roomDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RoomApi - object-oriented interface
 * @export
 * @class RoomApi
 * @extends {BaseAPI}
 */
export class RoomApi extends BaseAPI {
    /**
     * 
     * @summary Adds room to location
     * @param {string} locationId 
     * @param {RoomNewDto} roomNewDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomApi
     */
    public roomAddRoom(locationId: string, roomNewDto: RoomNewDto, options?: any) {
        return RoomApiFp(this.configuration).roomAddRoom(locationId, roomNewDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get rooms for given locationId
     * @param {string} locationId ObjectId for the location
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomApi
     */
    public roomGetRooms(locationId: string, options?: any) {
        return RoomApiFp(this.configuration).roomGetRooms(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} locationId 
     * @param {string} roomId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomApi
     */
    public roomRemoveRoom(locationId: string, roomId: string, options?: any) {
        return RoomApiFp(this.configuration).roomRemoveRoom(locationId, roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update room in location
     * @param {string} locationId 
     * @param {RoomDto} roomDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomApi
     */
    public roomUpdateRoom(locationId: string, roomDto: RoomDto, options?: any) {
        return RoomApiFp(this.configuration).roomUpdateRoom(locationId, roomDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SceneApi - axios parameter creator
 * @export
 */
export const SceneApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add new scene to location
         * @param {string} locationId 
         * @param {NewSceneDto} newSceneDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sceneAddScene: async (locationId: string, newSceneDto: NewSceneDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('sceneAddScene', 'locationId', locationId)
            // verify required parameter 'newSceneDto' is not null or undefined
            assertParamExists('sceneAddScene', 'newSceneDto', newSceneDto)
            const localVarPath = `/Scene/{locationId}/addScene`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newSceneDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Removes scene
         * @param {string} locationId 
         * @param {string} sceneId 
         * @param {number} version numeric version, not modificationVersion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sceneDeleteScene: async (locationId: string, sceneId: string, version: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('sceneDeleteScene', 'locationId', locationId)
            // verify required parameter 'sceneId' is not null or undefined
            assertParamExists('sceneDeleteScene', 'sceneId', sceneId)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('sceneDeleteScene', 'version', version)
            const localVarPath = `/Scene/{locationId}/{sceneId}/{version}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"sceneId"}}`, encodeURIComponent(String(sceneId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all scenes for location
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sceneGetScenesForLocation: async (locationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('sceneGetScenesForLocation', 'locationId', locationId)
            const localVarPath = `/Scene/{locationId}/getScenes`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Invoke scenes
         * @param {string} locationId 
         * @param {Array<string>} requestBody scenes ids, one or more
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sceneInvokeScenes: async (locationId: string, requestBody: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('sceneInvokeScenes', 'locationId', locationId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('sceneInvokeScenes', 'requestBody', requestBody)
            const localVarPath = `/Scene/{locationId}/invokeScene`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update scene definition
         * @param {string} locationId 
         * @param {UpdateSceneDto} updateSceneDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sceneUpdateScene: async (locationId: string, updateSceneDto: UpdateSceneDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('sceneUpdateScene', 'locationId', locationId)
            // verify required parameter 'updateSceneDto' is not null or undefined
            assertParamExists('sceneUpdateScene', 'updateSceneDto', updateSceneDto)
            const localVarPath = `/Scene/{locationId}/updateScene`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSceneDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SceneApi - functional programming interface
 * @export
 */
export const SceneApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SceneApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add new scene to location
         * @param {string} locationId 
         * @param {NewSceneDto} newSceneDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sceneAddScene(locationId: string, newSceneDto: NewSceneDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SceneDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sceneAddScene(locationId, newSceneDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Removes scene
         * @param {string} locationId 
         * @param {string} sceneId 
         * @param {number} version numeric version, not modificationVersion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sceneDeleteScene(locationId: string, sceneId: string, version: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sceneDeleteScene(locationId, sceneId, version, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all scenes for location
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sceneGetScenesForLocation(locationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SceneDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sceneGetScenesForLocation(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Invoke scenes
         * @param {string} locationId 
         * @param {Array<string>} requestBody scenes ids, one or more
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sceneInvokeScenes(locationId: string, requestBody: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sceneInvokeScenes(locationId, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update scene definition
         * @param {string} locationId 
         * @param {UpdateSceneDto} updateSceneDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sceneUpdateScene(locationId: string, updateSceneDto: UpdateSceneDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SceneDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sceneUpdateScene(locationId, updateSceneDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SceneApi - factory interface
 * @export
 */
export const SceneApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SceneApiFp(configuration)
    return {
        /**
         * 
         * @summary Add new scene to location
         * @param {string} locationId 
         * @param {NewSceneDto} newSceneDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sceneAddScene(locationId: string, newSceneDto: NewSceneDto, options?: any): AxiosPromise<SceneDto> {
            return localVarFp.sceneAddScene(locationId, newSceneDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Removes scene
         * @param {string} locationId 
         * @param {string} sceneId 
         * @param {number} version numeric version, not modificationVersion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sceneDeleteScene(locationId: string, sceneId: string, version: number, options?: any): AxiosPromise<any> {
            return localVarFp.sceneDeleteScene(locationId, sceneId, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all scenes for location
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sceneGetScenesForLocation(locationId: string, options?: any): AxiosPromise<Array<SceneDto>> {
            return localVarFp.sceneGetScenesForLocation(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Invoke scenes
         * @param {string} locationId 
         * @param {Array<string>} requestBody scenes ids, one or more
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sceneInvokeScenes(locationId: string, requestBody: Array<string>, options?: any): AxiosPromise<any> {
            return localVarFp.sceneInvokeScenes(locationId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update scene definition
         * @param {string} locationId 
         * @param {UpdateSceneDto} updateSceneDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sceneUpdateScene(locationId: string, updateSceneDto: UpdateSceneDto, options?: any): AxiosPromise<SceneDto> {
            return localVarFp.sceneUpdateScene(locationId, updateSceneDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SceneApi - object-oriented interface
 * @export
 * @class SceneApi
 * @extends {BaseAPI}
 */
export class SceneApi extends BaseAPI {
    /**
     * 
     * @summary Add new scene to location
     * @param {string} locationId 
     * @param {NewSceneDto} newSceneDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SceneApi
     */
    public sceneAddScene(locationId: string, newSceneDto: NewSceneDto, options?: any) {
        return SceneApiFp(this.configuration).sceneAddScene(locationId, newSceneDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Removes scene
     * @param {string} locationId 
     * @param {string} sceneId 
     * @param {number} version numeric version, not modificationVersion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SceneApi
     */
    public sceneDeleteScene(locationId: string, sceneId: string, version: number, options?: any) {
        return SceneApiFp(this.configuration).sceneDeleteScene(locationId, sceneId, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all scenes for location
     * @param {string} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SceneApi
     */
    public sceneGetScenesForLocation(locationId: string, options?: any) {
        return SceneApiFp(this.configuration).sceneGetScenesForLocation(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Invoke scenes
     * @param {string} locationId 
     * @param {Array<string>} requestBody scenes ids, one or more
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SceneApi
     */
    public sceneInvokeScenes(locationId: string, requestBody: Array<string>, options?: any) {
        return SceneApiFp(this.configuration).sceneInvokeScenes(locationId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update scene definition
     * @param {string} locationId 
     * @param {UpdateSceneDto} updateSceneDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SceneApi
     */
    public sceneUpdateScene(locationId: string, updateSceneDto: UpdateSceneDto, options?: any) {
        return SceneApiFp(this.configuration).sceneUpdateScene(locationId, updateSceneDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SnapInApi - axios parameter creator
 * @export
 */
export const SnapInApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Upload production volume snap-in list from a file to the database
         * @param {any} [fromFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapInAddProductionSnapInList: async (fromFile?: any, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/SnapIn/uploadProductionSnapInListFromFile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (fromFile !== undefined) { 
                localVarFormParams.append('fromFile', fromFile as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add new SnapIn to database
         * @param {SnapInProductNewDto} snapInProductNewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapInAddSnapIn: async (snapInProductNewDto: SnapInProductNewDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'snapInProductNewDto' is not null or undefined
            assertParamExists('snapInAddSnapIn', 'snapInProductNewDto', snapInProductNewDto)
            const localVarPath = `/SnapIn/addSnapIn`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(snapInProductNewDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add SnapIn to location
         * @param {string} [locationId] 
         * @param {string} [dockNumber] 
         * @param {string} [serialNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapInAddSnapInToLocation: async (locationId?: string, dockNumber?: string, serialNumber?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/SnapIn/addSnapInToLocation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (locationId !== undefined) {
                localVarQueryParameter['LocationId'] = locationId;
            }

            if (dockNumber !== undefined) {
                localVarQueryParameter['DockNumber'] = dockNumber;
            }

            if (serialNumber !== undefined) {
                localVarQueryParameter['SerialNumber'] = serialNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove SnapIn from database, snapIn must not be assigned to location
         * @param {string} [serialNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapInDeleteSnapIn: async (serialNumber?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/SnapIn/deleteSnapIn`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (serialNumber !== undefined) {
                localVarQueryParameter['serialNumber'] = serialNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove SnapIn assigned from location
         * @param {string} [locationId] 
         * @param {string} [serialNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapInDeleteSnapInFromLocation: async (locationId?: string, serialNumber?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/SnapIn/deleteSnapInFromLocation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }

            if (serialNumber !== undefined) {
                localVarQueryParameter['serialNumber'] = serialNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get one snapIn by serial number
         * @param {string} serialNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapInGetSnapIn: async (serialNumber: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'serialNumber' is not null or undefined
            assertParamExists('snapInGetSnapIn', 'serialNumber', serialNumber)
            const localVarPath = `/SnapIn/{serialNumber}`
                .replace(`{${"serialNumber"}}`, encodeURIComponent(String(serialNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get one snapIn by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapInGetSnapInById: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('snapInGetSnapInById', 'id', id)
            const localVarPath = `/SnapIn/id/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get SnapIn product for grid
         * @param {string} [criteriaSerialNumber] 
         * @param {string} [criteriaSnapInCode] 
         * @param {string} [criteriaLocationId] 
         * @param {string} [criteriaMacAddress] 
         * @param {string} [criteriaZigbeeId] 
         * @param {string} [orderBy] 
         * @param {boolean} [descending] 
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapInGetSnapIns: async (criteriaSerialNumber?: string, criteriaSnapInCode?: string, criteriaLocationId?: string, criteriaMacAddress?: string, criteriaZigbeeId?: string, orderBy?: string, descending?: boolean, pageNumber?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/SnapIn`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (criteriaSerialNumber !== undefined) {
                localVarQueryParameter['Criteria.SerialNumber'] = criteriaSerialNumber;
            }

            if (criteriaSnapInCode !== undefined) {
                localVarQueryParameter['Criteria.SnapInCode'] = criteriaSnapInCode;
            }

            if (criteriaLocationId !== undefined) {
                localVarQueryParameter['Criteria.LocationId'] = criteriaLocationId;
            }

            if (criteriaMacAddress !== undefined) {
                localVarQueryParameter['Criteria.MacAddress'] = criteriaMacAddress;
            }

            if (criteriaZigbeeId !== undefined) {
                localVarQueryParameter['Criteria.ZigbeeId'] = criteriaZigbeeId;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['OrderBy'] = orderBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['Descending'] = descending;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Saves modified location
         * @param {SnapInProductDto} snapInProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapInUpdateSnapIn: async (snapInProductDto: SnapInProductDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'snapInProductDto' is not null or undefined
            assertParamExists('snapInUpdateSnapIn', 'snapInProductDto', snapInProductDto)
            const localVarPath = `/SnapIn`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(snapInProductDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set SnapIn\'s status
         * @param {string} [serialNumber] 
         * @param {SnapInStatusEnum2} [snapInStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapInUpdateSnapInStatus: async (serialNumber?: string, snapInStatus?: SnapInStatusEnum2, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/SnapIn/updateSnapInStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (serialNumber !== undefined) {
                localVarQueryParameter['serialNumber'] = serialNumber;
            }

            if (snapInStatus !== undefined) {
                localVarQueryParameter['snapInStatus'] = snapInStatus;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SnapInApi - functional programming interface
 * @export
 */
export const SnapInApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SnapInApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Upload production volume snap-in list from a file to the database
         * @param {any} [fromFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snapInAddProductionSnapInList(fromFile?: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SnapInProductNewDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snapInAddProductionSnapInList(fromFile, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add new SnapIn to database
         * @param {SnapInProductNewDto} snapInProductNewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snapInAddSnapIn(snapInProductNewDto: SnapInProductNewDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SnapInProductDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snapInAddSnapIn(snapInProductNewDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add SnapIn to location
         * @param {string} [locationId] 
         * @param {string} [dockNumber] 
         * @param {string} [serialNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snapInAddSnapInToLocation(locationId?: string, dockNumber?: string, serialNumber?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SnapInProductDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snapInAddSnapInToLocation(locationId, dockNumber, serialNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove SnapIn from database, snapIn must not be assigned to location
         * @param {string} [serialNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snapInDeleteSnapIn(serialNumber?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snapInDeleteSnapIn(serialNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove SnapIn assigned from location
         * @param {string} [locationId] 
         * @param {string} [serialNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snapInDeleteSnapInFromLocation(locationId?: string, serialNumber?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snapInDeleteSnapInFromLocation(locationId, serialNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get one snapIn by serial number
         * @param {string} serialNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snapInGetSnapIn(serialNumber: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SnapInProductDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snapInGetSnapIn(serialNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get one snapIn by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snapInGetSnapInById(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SnapInProductDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snapInGetSnapInById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get SnapIn product for grid
         * @param {string} [criteriaSerialNumber] 
         * @param {string} [criteriaSnapInCode] 
         * @param {string} [criteriaLocationId] 
         * @param {string} [criteriaMacAddress] 
         * @param {string} [criteriaZigbeeId] 
         * @param {string} [orderBy] 
         * @param {boolean} [descending] 
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snapInGetSnapIns(criteriaSerialNumber?: string, criteriaSnapInCode?: string, criteriaLocationId?: string, criteriaMacAddress?: string, criteriaZigbeeId?: string, orderBy?: string, descending?: boolean, pageNumber?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfSnapInProductGridDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snapInGetSnapIns(criteriaSerialNumber, criteriaSnapInCode, criteriaLocationId, criteriaMacAddress, criteriaZigbeeId, orderBy, descending, pageNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Saves modified location
         * @param {SnapInProductDto} snapInProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snapInUpdateSnapIn(snapInProductDto: SnapInProductDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SnapInProductDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snapInUpdateSnapIn(snapInProductDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Set SnapIn\'s status
         * @param {string} [serialNumber] 
         * @param {SnapInStatusEnum2} [snapInStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snapInUpdateSnapInStatus(serialNumber?: string, snapInStatus?: SnapInStatusEnum2, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snapInUpdateSnapInStatus(serialNumber, snapInStatus, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SnapInApi - factory interface
 * @export
 */
export const SnapInApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SnapInApiFp(configuration)
    return {
        /**
         * 
         * @summary Upload production volume snap-in list from a file to the database
         * @param {any} [fromFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapInAddProductionSnapInList(fromFile?: any, options?: any): AxiosPromise<Array<SnapInProductNewDto>> {
            return localVarFp.snapInAddProductionSnapInList(fromFile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add new SnapIn to database
         * @param {SnapInProductNewDto} snapInProductNewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapInAddSnapIn(snapInProductNewDto: SnapInProductNewDto, options?: any): AxiosPromise<SnapInProductDto> {
            return localVarFp.snapInAddSnapIn(snapInProductNewDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add SnapIn to location
         * @param {string} [locationId] 
         * @param {string} [dockNumber] 
         * @param {string} [serialNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapInAddSnapInToLocation(locationId?: string, dockNumber?: string, serialNumber?: string, options?: any): AxiosPromise<SnapInProductDto> {
            return localVarFp.snapInAddSnapInToLocation(locationId, dockNumber, serialNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove SnapIn from database, snapIn must not be assigned to location
         * @param {string} [serialNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapInDeleteSnapIn(serialNumber?: string, options?: any): AxiosPromise<any> {
            return localVarFp.snapInDeleteSnapIn(serialNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove SnapIn assigned from location
         * @param {string} [locationId] 
         * @param {string} [serialNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapInDeleteSnapInFromLocation(locationId?: string, serialNumber?: string, options?: any): AxiosPromise<any> {
            return localVarFp.snapInDeleteSnapInFromLocation(locationId, serialNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get one snapIn by serial number
         * @param {string} serialNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapInGetSnapIn(serialNumber: string, options?: any): AxiosPromise<SnapInProductDto> {
            return localVarFp.snapInGetSnapIn(serialNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get one snapIn by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapInGetSnapInById(id: string, options?: any): AxiosPromise<SnapInProductDto> {
            return localVarFp.snapInGetSnapInById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get SnapIn product for grid
         * @param {string} [criteriaSerialNumber] 
         * @param {string} [criteriaSnapInCode] 
         * @param {string} [criteriaLocationId] 
         * @param {string} [criteriaMacAddress] 
         * @param {string} [criteriaZigbeeId] 
         * @param {string} [orderBy] 
         * @param {boolean} [descending] 
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapInGetSnapIns(criteriaSerialNumber?: string, criteriaSnapInCode?: string, criteriaLocationId?: string, criteriaMacAddress?: string, criteriaZigbeeId?: string, orderBy?: string, descending?: boolean, pageNumber?: number, options?: any): AxiosPromise<PagedResultOfSnapInProductGridDto> {
            return localVarFp.snapInGetSnapIns(criteriaSerialNumber, criteriaSnapInCode, criteriaLocationId, criteriaMacAddress, criteriaZigbeeId, orderBy, descending, pageNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Saves modified location
         * @param {SnapInProductDto} snapInProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapInUpdateSnapIn(snapInProductDto: SnapInProductDto, options?: any): AxiosPromise<SnapInProductDto> {
            return localVarFp.snapInUpdateSnapIn(snapInProductDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set SnapIn\'s status
         * @param {string} [serialNumber] 
         * @param {SnapInStatusEnum2} [snapInStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapInUpdateSnapInStatus(serialNumber?: string, snapInStatus?: SnapInStatusEnum2, options?: any): AxiosPromise<any> {
            return localVarFp.snapInUpdateSnapInStatus(serialNumber, snapInStatus, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SnapInApi - object-oriented interface
 * @export
 * @class SnapInApi
 * @extends {BaseAPI}
 */
export class SnapInApi extends BaseAPI {
    /**
     * 
     * @summary Upload production volume snap-in list from a file to the database
     * @param {any} [fromFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnapInApi
     */
    public snapInAddProductionSnapInList(fromFile?: any, options?: any) {
        return SnapInApiFp(this.configuration).snapInAddProductionSnapInList(fromFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add new SnapIn to database
     * @param {SnapInProductNewDto} snapInProductNewDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnapInApi
     */
    public snapInAddSnapIn(snapInProductNewDto: SnapInProductNewDto, options?: any) {
        return SnapInApiFp(this.configuration).snapInAddSnapIn(snapInProductNewDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add SnapIn to location
     * @param {string} [locationId] 
     * @param {string} [dockNumber] 
     * @param {string} [serialNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnapInApi
     */
    public snapInAddSnapInToLocation(locationId?: string, dockNumber?: string, serialNumber?: string, options?: any) {
        return SnapInApiFp(this.configuration).snapInAddSnapInToLocation(locationId, dockNumber, serialNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove SnapIn from database, snapIn must not be assigned to location
     * @param {string} [serialNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnapInApi
     */
    public snapInDeleteSnapIn(serialNumber?: string, options?: any) {
        return SnapInApiFp(this.configuration).snapInDeleteSnapIn(serialNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove SnapIn assigned from location
     * @param {string} [locationId] 
     * @param {string} [serialNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnapInApi
     */
    public snapInDeleteSnapInFromLocation(locationId?: string, serialNumber?: string, options?: any) {
        return SnapInApiFp(this.configuration).snapInDeleteSnapInFromLocation(locationId, serialNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get one snapIn by serial number
     * @param {string} serialNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnapInApi
     */
    public snapInGetSnapIn(serialNumber: string, options?: any) {
        return SnapInApiFp(this.configuration).snapInGetSnapIn(serialNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get one snapIn by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnapInApi
     */
    public snapInGetSnapInById(id: string, options?: any) {
        return SnapInApiFp(this.configuration).snapInGetSnapInById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get SnapIn product for grid
     * @param {string} [criteriaSerialNumber] 
     * @param {string} [criteriaSnapInCode] 
     * @param {string} [criteriaLocationId] 
     * @param {string} [criteriaMacAddress] 
     * @param {string} [criteriaZigbeeId] 
     * @param {string} [orderBy] 
     * @param {boolean} [descending] 
     * @param {number} [pageNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnapInApi
     */
    public snapInGetSnapIns(criteriaSerialNumber?: string, criteriaSnapInCode?: string, criteriaLocationId?: string, criteriaMacAddress?: string, criteriaZigbeeId?: string, orderBy?: string, descending?: boolean, pageNumber?: number, options?: any) {
        return SnapInApiFp(this.configuration).snapInGetSnapIns(criteriaSerialNumber, criteriaSnapInCode, criteriaLocationId, criteriaMacAddress, criteriaZigbeeId, orderBy, descending, pageNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Saves modified location
     * @param {SnapInProductDto} snapInProductDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnapInApi
     */
    public snapInUpdateSnapIn(snapInProductDto: SnapInProductDto, options?: any) {
        return SnapInApiFp(this.configuration).snapInUpdateSnapIn(snapInProductDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set SnapIn\'s status
     * @param {string} [serialNumber] 
     * @param {SnapInStatusEnum2} [snapInStatus] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnapInApi
     */
    public snapInUpdateSnapInStatus(serialNumber?: string, snapInStatus?: SnapInStatusEnum2, options?: any) {
        return SnapInApiFp(this.configuration).snapInUpdateSnapInStatus(serialNumber, snapInStatus, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Changes user password
         * @param {string} [id] user id
         * @param {string} [oldPassword] old password
         * @param {string} [newPassword] new password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersChangeUserPassword: async (id?: string, oldPassword?: string, newPassword?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/Users/changePassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (oldPassword !== undefined) {
                localVarQueryParameter['oldPassword'] = oldPassword;
            }

            if (newPassword !== undefined) {
                localVarQueryParameter['newPassword'] = newPassword;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of company names that starts on given parameter, case sensitive
         * @param {string} [companyName] begining of the company name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersCompanyNameLookup: async (companyName?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/Users/companyName`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (companyName !== undefined) {
                localVarQueryParameter['companyName'] = companyName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates new user
         * @param {UserNewDto} userNewDto Valid roles: administrator, installer             
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersCreateUser: async (userNewDto: UserNewDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userNewDto' is not null or undefined
            assertParamExists('usersCreateUser', 'userNewDto', userNewDto)
            const localVarPath = `/Users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userNewDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete user if user is not assigned to any location, otherwise disable user
         * @param {string} id user id to remove (cannot be the same as current logged user)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersDeleteUser: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('usersDeleteUser', 'id', id)
            const localVarPath = `/Users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get one user by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersGetBokitaUser: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('usersGetBokitaUser', 'id', id)
            const localVarPath = `/Users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get users list for given parameters and sorting criteria. Result is in pages
         * @param {string} [criteriaId] 
         * @param {string} [criteriaGivenName] 
         * @param {string} [criteriaSurname] 
         * @param {string} [criteriaMobilePhone] 
         * @param {string} [criteriaMail] 
         * @param {string} [criteriaCompanyName] 
         * @param {boolean} [criteriaDisabled] 
         * @param {string} [criteriaRole] 
         * @param {boolean} [criteriaAssigned] 
         * @param {string} [orderBy] 
         * @param {boolean} [descending] 
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersGetUsers: async (criteriaId?: string, criteriaGivenName?: string, criteriaSurname?: string, criteriaMobilePhone?: string, criteriaMail?: string, criteriaCompanyName?: string, criteriaDisabled?: boolean, criteriaRole?: string, criteriaAssigned?: boolean, orderBy?: string, descending?: boolean, pageNumber?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/Users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (criteriaId !== undefined) {
                localVarQueryParameter['Criteria.Id'] = criteriaId;
            }

            if (criteriaGivenName !== undefined) {
                localVarQueryParameter['Criteria.GivenName'] = criteriaGivenName;
            }

            if (criteriaSurname !== undefined) {
                localVarQueryParameter['Criteria.Surname'] = criteriaSurname;
            }

            if (criteriaMobilePhone !== undefined) {
                localVarQueryParameter['Criteria.MobilePhone'] = criteriaMobilePhone;
            }

            if (criteriaMail !== undefined) {
                localVarQueryParameter['Criteria.Mail'] = criteriaMail;
            }

            if (criteriaCompanyName !== undefined) {
                localVarQueryParameter['Criteria.CompanyName'] = criteriaCompanyName;
            }

            if (criteriaDisabled !== undefined) {
                localVarQueryParameter['Criteria.Disabled'] = criteriaDisabled;
            }

            if (criteriaRole !== undefined) {
                localVarQueryParameter['Criteria.Role'] = criteriaRole;
            }

            if (criteriaAssigned !== undefined) {
                localVarQueryParameter['Criteria.Assigned'] = criteriaAssigned;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['OrderBy'] = orderBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['Descending'] = descending;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Saves modified user
         * @param {UserDto} userDto Valid roles: administrator, installer             
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUpdateUser: async (userDto: UserDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userDto' is not null or undefined
            assertParamExists('usersUpdateUser', 'userDto', userDto)
            const localVarPath = `/Users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search by givenName and surname and return username and givenname and surname
         * @param {string} [userName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUserNameLookup: async (userName?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/Users/userName`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (userName !== undefined) {
                localVarQueryParameter['userName'] = userName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Changes user password
         * @param {string} [id] user id
         * @param {string} [oldPassword] old password
         * @param {string} [newPassword] new password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersChangeUserPassword(id?: string, oldPassword?: string, newPassword?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersChangeUserPassword(id, oldPassword, newPassword, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get list of company names that starts on given parameter, case sensitive
         * @param {string} [companyName] begining of the company name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersCompanyNameLookup(companyName?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersCompanyNameLookup(companyName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Creates new user
         * @param {UserNewDto} userNewDto Valid roles: administrator, installer             
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersCreateUser(userNewDto: UserNewDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersCreateUser(userNewDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete user if user is not assigned to any location, otherwise disable user
         * @param {string} id user id to remove (cannot be the same as current logged user)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersDeleteUser(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersDeleteUser(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get one user by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersGetBokitaUser(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersGetBokitaUser(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get users list for given parameters and sorting criteria. Result is in pages
         * @param {string} [criteriaId] 
         * @param {string} [criteriaGivenName] 
         * @param {string} [criteriaSurname] 
         * @param {string} [criteriaMobilePhone] 
         * @param {string} [criteriaMail] 
         * @param {string} [criteriaCompanyName] 
         * @param {boolean} [criteriaDisabled] 
         * @param {string} [criteriaRole] 
         * @param {boolean} [criteriaAssigned] 
         * @param {string} [orderBy] 
         * @param {boolean} [descending] 
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersGetUsers(criteriaId?: string, criteriaGivenName?: string, criteriaSurname?: string, criteriaMobilePhone?: string, criteriaMail?: string, criteriaCompanyName?: string, criteriaDisabled?: boolean, criteriaRole?: string, criteriaAssigned?: boolean, orderBy?: string, descending?: boolean, pageNumber?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersGetUsers(criteriaId, criteriaGivenName, criteriaSurname, criteriaMobilePhone, criteriaMail, criteriaCompanyName, criteriaDisabled, criteriaRole, criteriaAssigned, orderBy, descending, pageNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Saves modified user
         * @param {UserDto} userDto Valid roles: administrator, installer             
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersUpdateUser(userDto: UserDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersUpdateUser(userDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search by givenName and surname and return username and givenname and surname
         * @param {string} [userName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersUserNameLookup(userName?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserLookupResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersUserNameLookup(userName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @summary Changes user password
         * @param {string} [id] user id
         * @param {string} [oldPassword] old password
         * @param {string} [newPassword] new password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersChangeUserPassword(id?: string, oldPassword?: string, newPassword?: string, options?: any): AxiosPromise<any> {
            return localVarFp.usersChangeUserPassword(id, oldPassword, newPassword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of company names that starts on given parameter, case sensitive
         * @param {string} [companyName] begining of the company name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersCompanyNameLookup(companyName?: string, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.usersCompanyNameLookup(companyName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates new user
         * @param {UserNewDto} userNewDto Valid roles: administrator, installer             
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersCreateUser(userNewDto: UserNewDto, options?: any): AxiosPromise<UserDto> {
            return localVarFp.usersCreateUser(userNewDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete user if user is not assigned to any location, otherwise disable user
         * @param {string} id user id to remove (cannot be the same as current logged user)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersDeleteUser(id: string, options?: any): AxiosPromise<any> {
            return localVarFp.usersDeleteUser(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get one user by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersGetBokitaUser(id: string, options?: any): AxiosPromise<UserDto> {
            return localVarFp.usersGetBokitaUser(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get users list for given parameters and sorting criteria. Result is in pages
         * @param {string} [criteriaId] 
         * @param {string} [criteriaGivenName] 
         * @param {string} [criteriaSurname] 
         * @param {string} [criteriaMobilePhone] 
         * @param {string} [criteriaMail] 
         * @param {string} [criteriaCompanyName] 
         * @param {boolean} [criteriaDisabled] 
         * @param {string} [criteriaRole] 
         * @param {boolean} [criteriaAssigned] 
         * @param {string} [orderBy] 
         * @param {boolean} [descending] 
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersGetUsers(criteriaId?: string, criteriaGivenName?: string, criteriaSurname?: string, criteriaMobilePhone?: string, criteriaMail?: string, criteriaCompanyName?: string, criteriaDisabled?: boolean, criteriaRole?: string, criteriaAssigned?: boolean, orderBy?: string, descending?: boolean, pageNumber?: number, options?: any): AxiosPromise<PagedResultOfUserDto> {
            return localVarFp.usersGetUsers(criteriaId, criteriaGivenName, criteriaSurname, criteriaMobilePhone, criteriaMail, criteriaCompanyName, criteriaDisabled, criteriaRole, criteriaAssigned, orderBy, descending, pageNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Saves modified user
         * @param {UserDto} userDto Valid roles: administrator, installer             
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUpdateUser(userDto: UserDto, options?: any): AxiosPromise<UserDto> {
            return localVarFp.usersUpdateUser(userDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search by givenName and surname and return username and givenname and surname
         * @param {string} [userName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUserNameLookup(userName?: string, options?: any): AxiosPromise<Array<UserLookupResponse>> {
            return localVarFp.usersUserNameLookup(userName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * 
     * @summary Changes user password
     * @param {string} [id] user id
     * @param {string} [oldPassword] old password
     * @param {string} [newPassword] new password
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersChangeUserPassword(id?: string, oldPassword?: string, newPassword?: string, options?: any) {
        return UsersApiFp(this.configuration).usersChangeUserPassword(id, oldPassword, newPassword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of company names that starts on given parameter, case sensitive
     * @param {string} [companyName] begining of the company name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersCompanyNameLookup(companyName?: string, options?: any) {
        return UsersApiFp(this.configuration).usersCompanyNameLookup(companyName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates new user
     * @param {UserNewDto} userNewDto Valid roles: administrator, installer             
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersCreateUser(userNewDto: UserNewDto, options?: any) {
        return UsersApiFp(this.configuration).usersCreateUser(userNewDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete user if user is not assigned to any location, otherwise disable user
     * @param {string} id user id to remove (cannot be the same as current logged user)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersDeleteUser(id: string, options?: any) {
        return UsersApiFp(this.configuration).usersDeleteUser(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get one user by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersGetBokitaUser(id: string, options?: any) {
        return UsersApiFp(this.configuration).usersGetBokitaUser(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get users list for given parameters and sorting criteria. Result is in pages
     * @param {string} [criteriaId] 
     * @param {string} [criteriaGivenName] 
     * @param {string} [criteriaSurname] 
     * @param {string} [criteriaMobilePhone] 
     * @param {string} [criteriaMail] 
     * @param {string} [criteriaCompanyName] 
     * @param {boolean} [criteriaDisabled] 
     * @param {string} [criteriaRole] 
     * @param {boolean} [criteriaAssigned] 
     * @param {string} [orderBy] 
     * @param {boolean} [descending] 
     * @param {number} [pageNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersGetUsers(criteriaId?: string, criteriaGivenName?: string, criteriaSurname?: string, criteriaMobilePhone?: string, criteriaMail?: string, criteriaCompanyName?: string, criteriaDisabled?: boolean, criteriaRole?: string, criteriaAssigned?: boolean, orderBy?: string, descending?: boolean, pageNumber?: number, options?: any) {
        return UsersApiFp(this.configuration).usersGetUsers(criteriaId, criteriaGivenName, criteriaSurname, criteriaMobilePhone, criteriaMail, criteriaCompanyName, criteriaDisabled, criteriaRole, criteriaAssigned, orderBy, descending, pageNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Saves modified user
     * @param {UserDto} userDto Valid roles: administrator, installer             
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersUpdateUser(userDto: UserDto, options?: any) {
        return UsersApiFp(this.configuration).usersUpdateUser(userDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search by givenName and surname and return username and givenname and surname
     * @param {string} [userName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersUserNameLookup(userName?: string, options?: any) {
        return UsersApiFp(this.configuration).usersUserNameLookup(userName, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ZigbeeSettingsApi - axios parameter creator
 * @export
 */
export const ZigbeeSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Sets zigbee settings such as channel, network key, pan id.
         * @param {string} locationId Location ID.
         * @param {string} bcbId BCB ID.
         * @param {ZigbeeSettingsDto} zigbeeSettingsDto Zigbee settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zigbeeSettingsSet: async (locationId: string, bcbId: string, zigbeeSettingsDto: ZigbeeSettingsDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('zigbeeSettingsSet', 'locationId', locationId)
            // verify required parameter 'bcbId' is not null or undefined
            assertParamExists('zigbeeSettingsSet', 'bcbId', bcbId)
            // verify required parameter 'zigbeeSettingsDto' is not null or undefined
            assertParamExists('zigbeeSettingsSet', 'zigbeeSettingsDto', zigbeeSettingsDto)
            const localVarPath = `/ZigbeeSettings/set/{locationId}/{bcbId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"bcbId"}}`, encodeURIComponent(String(bcbId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(zigbeeSettingsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ZigbeeSettingsApi - functional programming interface
 * @export
 */
export const ZigbeeSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ZigbeeSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Sets zigbee settings such as channel, network key, pan id.
         * @param {string} locationId Location ID.
         * @param {string} bcbId BCB ID.
         * @param {ZigbeeSettingsDto} zigbeeSettingsDto Zigbee settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async zigbeeSettingsSet(locationId: string, bcbId: string, zigbeeSettingsDto: ZigbeeSettingsDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.zigbeeSettingsSet(locationId, bcbId, zigbeeSettingsDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ZigbeeSettingsApi - factory interface
 * @export
 */
export const ZigbeeSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ZigbeeSettingsApiFp(configuration)
    return {
        /**
         * 
         * @summary Sets zigbee settings such as channel, network key, pan id.
         * @param {string} locationId Location ID.
         * @param {string} bcbId BCB ID.
         * @param {ZigbeeSettingsDto} zigbeeSettingsDto Zigbee settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zigbeeSettingsSet(locationId: string, bcbId: string, zigbeeSettingsDto: ZigbeeSettingsDto, options?: any): AxiosPromise<any> {
            return localVarFp.zigbeeSettingsSet(locationId, bcbId, zigbeeSettingsDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ZigbeeSettingsApi - object-oriented interface
 * @export
 * @class ZigbeeSettingsApi
 * @extends {BaseAPI}
 */
export class ZigbeeSettingsApi extends BaseAPI {
    /**
     * 
     * @summary Sets zigbee settings such as channel, network key, pan id.
     * @param {string} locationId Location ID.
     * @param {string} bcbId BCB ID.
     * @param {ZigbeeSettingsDto} zigbeeSettingsDto Zigbee settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZigbeeSettingsApi
     */
    public zigbeeSettingsSet(locationId: string, bcbId: string, zigbeeSettingsDto: ZigbeeSettingsDto, options?: any) {
        return ZigbeeSettingsApiFp(this.configuration).zigbeeSettingsSet(locationId, bcbId, zigbeeSettingsDto, options).then((request) => request(this.axios, this.basePath));
    }
}


